<template>
  <div :class="['slideshow',{isload:isLoading}]"
       @contextmenu.prevent="windowRightMenu"
       @touchstart="touchstarts($event)"
       @touchmove="touchmoves()"
       @touchend="touchends()">
    <div :class="['havrTransform',$store.state.pageFontSize?$store.state.pageFontSize:'']">
      <div class="showHave"
          v-if="!outSrc">
        <div :class="['navbars specialPage',backGroundCol ? ('navbars'+backGroundCol) : '',{'specialTop':specialTop}]" v-if="(!(getQuery('brush')||getQuery('topType')) || forward) && !forward" @contextmenu.stop.prevent="windowRightMenu($event,'show','top')" @touchstart="touchstarts($event,'show','top')" @touchmove="touchmoves()" @touchend="touchends()">
          <template v-if="!specialTop">
            <span class="nav-left">
              <div class="left fl">
                <div style="display:flex;cursor:pointer;">
                  <div class="picture">
                    <img :src="imgages" v-show="imgages"
                        alt="">
                  </div>
                  <div class="title">
                    <div>
                      <div @click="reloads()"
                          class="titleName">
                        <span v-if="!iframeSrc&&!showSlide||that.location.href.indexOf('thirdUrl') > -1||that.location.href.indexOf('docId') > -1||that.location.href.indexOf('productUrl') > -1 || that.location.href.indexOf('socialId') > -1||that.location.href.indexOf('platformUrl') > -1 || isFlowDetail"
                              :title="odzidName">{{odzidName}}</span>
                        <span v-else
                              title="社交智三宝">社交智三宝</span>
                      </div>
                    </div>
                  </div>
                  <div class="metaverse">
                    <div style="fontSize:17px;">
                      <span>元宇宙</span>
                    </div>
                    <div style="fontSize:12px;maxWidth:100px;overflow: hidden;">{{showUrl}}</div>
                  </div>
                </div>
                <!-- 下拉框 -->
                <!-- <div class="selcctChoice">
                  <img src="~@/assets/image/images/open_icon_white.png"
                      alt=""
                      @click.stop.prevent="selectDesp();">
                  <div class="selects"
                      v-show="selectDes">
                    <span>
                      <input type="text"
                            ref="input_des"
                            v-model="inputCon"
                            @click.stop.prevent="">
                    </span>
                    <ul class="selcctChoice-C">
                        <dropdownLeave v-for="(item,index) in infoName" :key="index" :Str="item" :inputCon="inputCon"></dropdownLeave>
                        <li class="selcctChoice-C-l" v-show="noResults">No results found</li>
                    </ul>
                    <div class="GRLI-sortadd">
                      <a href="javascript:;" @click="openMainToolsiframe()">
                        <img src="https://520ezj.com/zjstatic/standard/images/icons/more1_blue.png">添加
                      </a>
                    </div>
                  </div>
                </div> -->
              </div>
            </span>
            <socialize @emitJumpUrl="jumpUrl" :sanbaoId="sanbaoId" @emitHide="hideSel" ref="sonHtml" v-if="that.location.search.indexOf('pfId') > -1||!that.location.search" />
            <span v-else class="nav-center">
              <span v-for="(item,ind) in sanbaooperate" :key="ind" @click="jumpUrl(item)">{{item.name}}</span>
            </span>
          </template>
          <span class="nav-right">
            <div class="right fr">
              <nav-top @jumpUrl="jumpUrl" v-if="!specialTop"/>
              <ul class="icon-box fr">
                <li class="setup fr pictures"
                    @click="goback('back')">
                  <img :src="require('../assets/image/images/btn _return.png')">
                </li>
                <li class="setup fr pictures"
                    @click="goback('min')">
                  <img :src="require('../assets/image/images/mail_minimum.png')">
                </li>
                <li class="setup fr pictures"
                    @click="goback('max');minMax = !minMax;">
                  <img :src="minMax ? require('../assets/image/images/mail_big.png'):require('../assets/image/images/mail_normal.png')">
                </li>
                <li class="setup fr pictures"
                    @click="goback('close')">
                  <img :src="require('../assets/image/images/deliverable_close.png')">
                </li>
              </ul>
            </div>
          </span>
        </div>
        <!-- 有参数状态 -->
        <div v-if="!iframeSrc&&!showSlide"
            class="haveParameter"
            :style="getQuery('topType')?'height:100%':''">
          <div class="backgroundDiv"
              v-show="backgroundDiv&&!startIframe&&!endIframe&&topShow&&!isShowMore"></div>
          
          <flowDetail :showName="showName"
                      v-if="!getQuery('forwardId')"
                      ref="newFlowDetail"
                      @topShow="topShow=true;"
                      @windowRight="windowRightMenu"
                      :publish="publish"
                      :blockData="blockData"
                      :name="oneName.detailName"
                      :numb="0"></flowDetail>

          <!-- <forward v-if="getQuery('forwardId')" @changeOdzidName="changeOdzidName"></forward> -->
          <forward v-if="getQuery('forwardId')"></forward>
          <div class="floorBox advertisement" v-if="$store.state.showOther"  :style="{width:isPC?'1200px':'100%'}">
            <img class="backImg" :src="isPC?require('../assets/image/images/wz_gg.png') : require('../assets/image/images/wz_gg_xp.png')" alt="">
            <img class="knowMore" @click="knowMore" src="../assets/image/images/ljgd.png" alt="">
          </div>
          <template v-if="!topShow&&$store.state.showOther">
            <!-- 想挣钱，去落地 -->
            <div class="floorBox" :style="{width:isPC?'1198px':'calc(100% - 2px)'}">
              <ul class="titles clearfix">
                <topButton :content="[{'detailName':'想挣钱，去落地','enName':'qzc'}]"></topButton>
              </ul>
              <div v-show="qldShow">
                <div class="tab clearfix" :style="{margin:tabCalc>scrollWidth?0 : '0 16px'}">
                  <div class="arrow-box arrow-box-left fl" :style="{display:tabCalc>scrollWidth?'block':'none'}" @click="changeLeftFn" >
                      <img src="https://520ezj.com/zjstatic/standard/images/icons/submenu_left_arrow.png" />
                  </div>
                  <div class="tab-box clearfix fl" ref="scrollDom" :style="{width:tabCalc>scrollWidth? 'calc(100% - 36px)': '100%'}">
                    <div class="tab-change clearfix" :style="{marginLeft:`${marginLeft}px`}">
                      <div :class="['row','fl',{'curr':ind == chooseIndex}]" v-for="(ite,ind) in chooseTab" :key="ind" >
                        <a href="javascript:;" @click="chooseIndex = ind">{{ite}}</a>
                      </div>
                    </div>
                  </div>
                  <div class="arrow-box arrow-box-right fl" :style="{display:tabCalc>scrollWidth?'block':'none'}" @click="changeRightFn">
                      <img src="https://520ezj.com/zjstatic/standard/images/icons/submenu_left_arrow.png" />
                  </div>
                </div>
                <div v-show="chooseIndex == 0">
                  <iframe :src="getRegisterLink('ret')" frameborder="0" width="100%" height="442"></iframe>
                </div>
                <iframe v-show="chooseIndex == 1" :src="cwdl" frameborder="0" width="100%" height="442"></iframe>
                <iframe v-show="chooseIndex == 2" :src="jrzx" frameborder="0" width="100%" height="442"></iframe>
              </div>
              <ShowMore  @getMore="qldShow = !qldShow,qldMore()" spec="true"></ShowMore>
            </div>
            <!-- 加入直销，成为智能新贵 -->
            <div class="floorBox" :style="{width:isPC?'1198px':'calc(100% - 2px)'}">
              <ul class="titles clearfix">
                <topButton :content="[{'detailName':'加入直销，成为智能新贵','enName':'znxg'}]"></topButton>
              </ul>
              <iframe :src="cwznxg" frameborder="0" v-show="znxgShow" width="100%" height="472"></iframe>
              <ShowMore  @getMore="znxgShow = !znxgShow" spec="true"></ShowMore>
            </div>
          </template>    
          <template v-if="(newDetail && $store.state.showOther && finish || dataAssetId) && !getQuery('forwardId')">
            
              <ShowMore v-if="isShowMore" @getMore="showMore = !showMore"></ShowMore>
              <div v-show="!showMore">
                <div v-if="Demonstrations && getQuery('dataType') != 6">
                  <!-- 产品横向排列 -->
                  <div v-if="relatedIntroduction" class="floorBox" :style="{width:isPC?'1198px':'calc(100% - 2px)'}">
                    <ul class="titles clearfix">
                      <topButton @changeBut='changeBut' :content="Name4"></topButton>
                    </ul>
                    <div class="bottom-box-right"> 
                      <haowu :contentData="contentData"
                        :blockData="blockDataId"
                        :key="blockDataId.id"
                        :types="types"
                        :newBanner="true"
                        @arrowRight='getSeckill'
                        @emitContextMenuItem="leftRightMove">
                      </haowu>
                    </div>
                  </div>
                  <!-- 产品竖向排列 -->
                  <div v-else>
                    <div class="floorBox" :style="{width:isPC?'1198px':'calc(100% - 2px)'}" v-show="item.showOrFalse" v-for="(item,ind) in Name4" :key="ind">
                      <ul class="titles clearfix">
                        <topButton :content="[item]"></topButton>
                      </ul>
                      <div class="bottom-box-right"> 
                        <haowu :contentData="[]"
                          :blockData="{'id':item.id}"
                          :key="item.id"
                          :types="item.enName"
                          :pageSize="pageNum"
                          :newBanner="true"
                          @hiddenFloor="hiddenFloor"
                          @emitContextMenuItem="leftRightMove">
                        </haowu>
                      </div>
                    </div>
                  </div>
                  <!-- 商品介绍 -->
                  <div class="floorBox" :style="{width:isPC?'1198px':'calc(100% - 2px)'}">
                    <ul class="titles clearfix">
                      <topButton @changeBut='changeBut1' :content="Name5"></topButton>
                    </ul>
                    <div v-show="!pingjia">
                      <div v-if="relatedIntroduction" class="Introduction">
                        <div v-for="(item,index) in relatedIntroduction" :key="index">
                          <span v-if="item.floorType == 'TEXTAREA'">{{item.floorContent}}</span>
                          <img v-else-if="item.floorType == 'IMG'" :src="item.floorContent" />
                          <Video v-else-if="item.floorType == 'VIDEO'" :src="item.floorContent" width="100%"></Video>
                        </div>
                      </div>
                      <div v-else class="noIntroduction">
                        <img :src="require('../assets/image/images/none_introduce.png')">
                        <span>暂无介绍</span>
                      </div>
                    </div>
                    <pingjia class="evaluations" v-show="pingjia"></pingjia>
                  </div>
                </div>
                <!-- 相关推荐 -->
                <div v-else class="floorBox"  :style="{width:isPC?'1198px':'100%'}">
                  <ul class="titles clearfix">
                    <topButton @changeBut='changeBut2' :content="Name6"></topButton>
                  </ul>
                  <div v-if="xgwzContent.length" class="related">
                    <div :class="['related-articles',{'last':!recommendShowMore&&index==8 || recommendShowMore&&index==xgwzContent.length - 1}]" v-for="(item,index) in xgwzContent" :key="index" v-show="recommendShowMore? true : index<10" @click="jumpWzUrl(item)">
                      <div v-if="item.stanardByMainFigureData || item.logoUrl" :class="['related-articles-imgOrVideo',{'gzkh':item.logoUrl}]">
                        <ZImage :value="item.stanardByMainFigureData || item.logoUrl ? item.stanardByMainFigureData || item.logoUrl :''"/>
                      </div>
                      <followMembers :area="true" :ite="item" :user-id="$store.state.userInfo.userId || ''" :pf-id="pfId" v-if="item.logoUrl"></followMembers>
                      <div class="related-articles-text" v-else>
                        <span class="related-articles-text-title">{{item.stanardByAppNameData}}</span>
                        <span class="related-articles-text-content">{{item.stanardByProductBriefData}}</span>
                        <span class="related-articles-text-article">{{item.userName || item.appName}} {{item.submitTime}}</span>
                      </div>
                    </div>
                    <div class="showMore retract" @click="recommendShowMore = !recommendShowMore"  :style="{width:isPC?'1156px':'100%'}">
                      
                      <div class="text"><a :class="['iconfont', recommendShowMore ? 'icon-fanhuishangshuangjiantou' : 'icon-fanhuixiashuangjiantou']"></a ><span>{{recommendShowMore ? '收起' : '更多'}}</span></div>
                    </div>  
                  </div>
                  <div v-else class="noIntroduction">
                        <img :src="require('../assets/image/images/none_introduce.png')">
                        <span>暂无介绍</span>
                      </div>
                </div>
              </div>
          </template>
          <div class="startIframe"
              :style="{height:centerHeight}"
              v-if="startIframe || endIframe">
            <div><img :src="require('../assets/image/images/guoqi.png')"
                  alt=""></div>
            <div><span>交付物有效期为：</span><span style="color:#999">{{startIframe || endIframe}}</span></div>
            <div><span v-show="startIframe">现未开始无法查询</span><span v-show="endIframe">现已过期无法查询</span></div>
          </div>
          <div class="bottom" v-show="($store.state.showOther && finish || dataAssetId) || getQuery('forwardId')">
            <span v-show="isFlowDetail">声明：本站部分文章、图片来源于网络，为第三方供稿，著作权归原作者所有，本站不承担因第三方所供稿件而产生的相关责任。如有侵权，请联系本站删除。</span>
            <span>© 2016-{{that.$dataTime.getFullYear()}} 传媒交付物智人 odzid.com 版权所有 保留所有权利<a href="https://beian.miit.gov.cn/"
                target="_blank">&nbsp;豫ICP备16016646号-26</a></span>
          </div>
        </div>
        <!-- 无参数默认状态 -->
        <div v-else-if="!iframeSrc&&showSlide"
            class="shiyong-client"
            :style="getQuery('topType')?'height:100%':''">
          <div class="iframeShow" :style="{height:centerHeight}">
            <iframe :src="that.location.origin + '/zciid-deliverable/api/abduction/triratna/socialList?userId=' + $store.state.userInfo.userId + '&pfId=' + (getQuery('pfId') ? getQuery('pfId') : $blockGetData.getpfId())"
                    frameborder="0"
                    id='deliverable'
                    width="100%"
                    height="100%"></iframe>
          </div>
          <div class="bottom">
            <span v-show="isFlowDetail">声明：本站部分文章、图片来源于网络，为第三方供稿，著作权归原作者所有，本站不承担因第三方所供稿件而产生的相关责任。如有侵权，请联系本站删除。</span>
            <span>© 2016-{{that.$dataTime.getFullYear()}} 社交智三宝 odzid.com 版权所有 保留所有权利<a href="https://beian.miit.gov.cn/"
                target="_blank">&nbsp;豫ICP备16016646号-26</a></span>
          </div>
        </div>
        <div v-else
            class="showHave-l"
            :style="getQuery('brush')||getQuery('topType')?'height:100%':''">
          <div :style="{width:'100%',height:centerHeight,fontSize:0,overflow:'hidden'}">
            <iframe :src="iframeSrc"
                    v-if="!thirdContent.state"
                    id="deliverable"
                    frameborder="0"
                    width="100%"
                    height="100%"></iframe>
            <!-- <deliverableDetail v-else-if="getQuery('brush')" :blockData="blockData"></deliverableDetail> -->
            <component :is="currentTab" v-else-if="getQuery('brush')" :blockData="blockData"></component>
            <div style="width:100%;height:100%;"
                v-else>
              <div class="thirdUrlError" :style="{height:centerHeight}"
                  v-if="IsMobile()">
                <img :src="require('../assets/image/images/warn_sigh.png')"
                    alt="">
                <span style="fontSize:16px;fontWeight:600;">即将离开三宝客户端</span>
                <div>
                  <span>你即将通过访问链接离开三宝客户端，请注意你的账号和信息安全，建议谨慎访问。</span>
                  <span>即将访问{{thirdContent.name}}</span>
                  <a @click="specialTreatment(thirdContent)">{{thirdContent}}</a>
                </div>
              </div>
              <webview :src="iframeSrc"
                      v-else
                      frameborder="0"
                      id='targetSite'
                      style="width:100%;height:100%;"></webview>
            </div>
          </div>
          <div class="bottom">
            <span v-show="isFlowDetail">声明：本站部分文章、图片来源于网络，为第三方供稿，著作权归原作者所有，本站不承担因第三方所供稿件而产生的相关责任。如有侵权，请联系本站删除。</span>
            <span>© 2016-{{that.$dataTime.getFullYear()}} 社交智三宝 odzid.com 版权所有 保留所有权利<a href="https://beian.miit.gov.cn/"
                target="_blank">&nbsp;豫ICP备16016646号-26</a></span>
          </div>
        </div>
      </div>
      <iframe v-else
              :src="outSrc"
              width="100%"
              height="100%"
              frameborder="0"></iframe>

      <!-- 右键 -->
      <div class="right-menu"
          @contextmenu.stop.prevent=""
          @mousedown.stop=""
          @touchstart.stop=""
          @click.stop=""
          v-if="rightShow&&Object.keys(rightContent || '').length"
          :style="{top:`${rMenuPos.top}px`,left:`${rMenuPos.left}px`}">
        <el-cascader-panel @expand-change="handleExpandChange" :props="{ expandTrigger: 'hover', label:'menuName', value:'childmenu',children:'children' }"
                          :options="rightContent">
          <li slot-scope="{data}"
              :title="data.menuName"
              @click="liNewHoverFun(data)"
              @mouseenter="liNewHoverFunEnter(data)">
            <span>{{data.menuName}}</span>
          </li>
        </el-cascader-panel>
      </div>
    </div>
    <!-- 右下角对话框 -->
    <div :class="['open',$store.state.pageFontSize?$store.state.pageFontSize:'']" v-if="!outSrc && getQuery('showMore') != 'false'&& !detail">
      <ul class="hovers" @touchstart.stop=''>
        
        <li @click.stop="openLayerWin('register')" @mouseenter="hoversTwoShow = false">注册</li>
        <template v-if="outermost">
        <li @click.stop="openLayerWin('login')" @mouseenter="hoversTwoShow = false"
            v-if='!hasLogin'>登录</li>
        <li @click.stop="openLayerWin('handleLogout')" @mouseenter="hoversTwoShow = false"
            v-else>退出</li>
        </template>
        <!-- <li v-if="!(!iframeSrc&&!showSlide)" @click.stop="openLayerWin('Chatbot')" @mouseenter="hoversTwoShow = false">聊天机器人</li> -->
        <li @click.stop="openLayerWin('immediate')" @mouseenter="hoversTwoShow = false"><div class="redpoint" v-show="window.$redpoint"></div>即时通讯</li>
        <li @click.stop="openLayerWin('voice')" @mouseenter="hoversTwoShow = false"><div class="redpoint" v-show="window.$redpoint"></div>语音通讯</li>
        <li @click.stop="openLayerWin('def')" @mouseenter="hoversTwoShow = false"><div class="redpoint" v-show="window.$redpoint"></div>视频通讯</li>
        <li @click.stop="openLayerWin('organization')" @mouseenter="hoversTwoShow = false"><div class="redpoint" v-show="window.$redpoint"></div>同屏通讯</li>
        <em v-if="!iframeSrc&&!showSlide">
          <!-- <li @click="changOption()" 
          @mouseenter="hoversTwoShow = false"
              :style="{'color':parseInt(initData.like)?'#0c78cf':''}">点赞 {{initData.likeNum}}</li>
          <li @mouseenter="hoversTwoShowFun"
              >转发 {{initData.transmitNum}} <i class="el-icon-arrow-right el-cascader-node__postfix"></i></li>
          <li @click.stop="changOptions()"
          @mouseenter="hoversTwoShow = false"
              :style="{'color':parseInt(initData.collect)?'#0c78cf':''}">收藏 {{initData.collectNum}}</li> -->
          <li @click="changOption('/zciid-deliverable/form/xydoc?id=#contentId&pfId=#pfId','小元文档')" 
          @mouseenter="hoversTwoShow = false">小元文档</li>
          <li @click.stop="changOption('/zciid-deliverable/grab/start/edit?dataType=friendUpdate&mainId=#contentId&userId=#userId&userName=#userName&pfId=#pfId','友情上传')"
          @mouseenter="hoversTwoShow = false">友情上传</li>
          <li @mouseenter="hoversTwoShowFun(0)">更新发布<i class="el-icon-arrow-right el-cascader-node__postfix"></i></li>
          <li @mouseenter="hoversTwoShowFun(1)">同屏会议<i class="el-icon-arrow-right el-cascader-node__postfix"></i></li>
        </em>
      </ul>
      <ul class="hoversTwo"
          v-show="hoversTwoShow"
          @mouseenter="hoversTwoShow = true"
          @mouseleave="hoversTwoShow = false">
        <li v-for="(item,ind) in contents"
            :key="ind"
            @click="suspendEnter(item)">{{item.name}}</li>
      </ul>
      <!-- <div v-show="suspendShow"
          @mouseenter="suspendShow = true;hoversTwoShow = true"
          @mouseleave="suspendShow = false;hoversTwoShow = false"
          class="suspendShow">
        <iframe :src="iframeUrl"
                width="100%"
                height="100%"
                frameborder="0"></iframe>
      </div> -->
      <!-- <span>小元在线</span> -->
      <div class="supFloat"></div>
      <div class="redpoint" v-show="window.$redpoint"></div>
    </div>
  </div>
</template>
<script>
import forward from "../components/floorBlock/forward.vue"
import Video from "../components/videos.vue"
import paging from '../components/paging.vue'
import haowu from '../components/haowutuijian.vue'
import pingjia from "../components/floorBlock/xiangguanpingjia.vue"
import jinriShow from "../components/floorBlock/jinriShowContent.vue"
import topButton from "../components/floorBlock/topChangeButton.vue";
import smartAppSameScreenShow from "../components/floorBlock/detailShow.vue";
import { menu, appendMenu, authLoginMenu } from "../menu.js";
import ZImage from "../components/ZImage.vue";
import flowDetail from "./newFlowDetail.vue";
import topFans from "../components/newFlowDetail/topFans.vue";
import deliverableDetail from "../components/deliverableDetail.vue";
import deliverableDetailLook from "../components/deliverableDetailLook.vue";
import deliverableDetailChat from "../components/deliverableDetailChat.vue";
import Bus from '../bus.js'
import NavTop from "../components/NavTop.vue";
import socialize from "../components/socialize.vue";
import dropdownLeave from "../components/DropdownLeave.vue";
import followMembers from "../components/followMembers.vue";
import minBase from "../mixins/mix-base.vue";
import { flatArrMenu, initTreeMenu } from '../store/helper.js'
import ShowMore from './showMore.vue'
export default {
  name: 'SlideshowAllShow',
  components: {
    ZImage,
    smartAppSameScreenShow,
    Bus,
    flowDetail,
    topFans,
    deliverableDetail,
    deliverableDetailLook,
    deliverableDetailChat,
    NavTop,
    socialize,
    topButton,
    jinriShow,
    pingjia,
    haowu,
    paging,
    Video,
    dropdownLeave,
    followMembers,
    forward,
    ShowMore
  },
  data () {
    return {
      publish:{},
      marginLeft:0,
      speed:0,
      scrollWidth:0,
      tabCalc:332,
      chooseTab:['去注册','成为智能产品代理','加入数据资产直销'],
      chooseIndex:0,
      window:window,
      currentTab:'',
      isLoading:true,
      forward:this.getQuery('forwardId'),
      isShowMore:this.getQuery('showMore') == 'true' ? true : false,
      showMore:this.getQuery('showMore') ? true : false,
      znxgShow:false,
      qldShow:false,
      recommendShowMore:false,
      dataAssetId: this.getQuery('assetId'),
      finish:false,
      Demonstrations:true,
      totalPage: 0,
      endPage: 1,
      pageSize:10,
      pageNum:5,
      currentPage:1,
      xgwzContent:[],
      Name4: [{'detailName':'主营产品','enName':'zycp','id':'zycp-9348747','showOrFalse':true},{'detailName':'相关推荐','enName':'xytj','id':'xytj-93409780','showOrFalse':true},{'detailName':'热门精选','enName':'scrx','id':'scrx-934u09897','showOrFalse':true},{'detailName':'热门推荐','enName':'rmgz','id':'rmgz-93409809','showOrFalse':true},{'detailName':'猜你喜欢','enName':'scxp','id':'scxp-9348790','showOrFalse':true},{'detailName':'产品业绩','enName':'cpyj','id':'cpyj-93479879','showOrFalse':true},{'detailName':'相关专项','enName':'xgzx','id':'xgzx-9348790','showOrFalse':true},{'detailName':'关注客户','enName':'gzkh','id':'gzkh-9348790','showOrFalse':true}],
      Name6:[{'detailName':'相关推荐','enName':'xgwz'}],
      // Name5:[{'detailName':'商品介绍'},{'detailName':'商品评价'}],
      Name5:[{'detailName':'商品评价'}],
      imgages:'',
      topShow: this.getQuery('dataType') ? false : true,//顶部蓝色头部
      odzidName: this.getQuery('id') || this.getQuery('thirdUrl') || this.getQuery('dataType') || this.getQuery('docId') ? '' : '我的工作',
      //从export.js传过来
      infoName: [],
      inputCon: '',
      selectDes: false,
      showUrl: '',
      that: window,
      startIframe: false,
      endIframe: false,
      initData: {},
      // contents: ['转发到商圈', '转发给好友', '转发到好友圈', '分享'],
      contents: [],
      iframeUrl: '',
      suspendShow: false,
      hoversTwoShow: false,
      backgroundDiv: window.innerWidth > 1230,
      outSrc: '',
      Name: [],
      oneName: '',
      lastName: '',
      rightType: this.$store.state.rightType,
      sdgka: [],
      blockData: {},
      timeOutEvent: 0,
      iframeSrc: '',
      pictures: '',
      video: '',
      file: '',
      index: 0,
      showSlide: false,
      rightShow: false,
      rMenuPos: {
        left: 0,
        top: 0
      },
      rightMenus: null,
      topRightMenus: null,
      bottomRightMenus: null,
      ind: '',
      isdefault: true,
      showName: [],
      thirdContent: { 'state': 0 },
      SpecialUrl: [],
      theme: '',
      backGroundCol:'',
      // pingjia:0,
      pingjia:1,
      relatedIntroduction:'',
      contentData: [],
      types:'zycp',
      Xgtypes:'xgwz',
      blockDataId:{'id':'zycp-9348747'},
      minMax:true,
      noResults:false,
      cont:[],
      sanbaooperate:[{name:'首页',url:''}],
      pfId:this.getQuery('pfId') ? this.getQuery('pfId') : window.$pfId,
      sanbaoId:'',
      centerHeight:0,
      haowuRight:true,
      topRight:true,
      hideTop:this.getQuery('hideTop'),
      jumpLink:'',
      contentName:'',
      znxgAppName:''
    }
  },
  mixins:[minBase],
  async created () {
    var _this = this;
    if (_this.getQuery('checkCode')) {
      _this.outSrc = '1';
      let res = await _this.$http.get('/zciid-deliverable/api/third/issue/deleteCheckOutWay.json', { contentId:_this.$contentId
      ,checkCode:_this.getQuery('checkCode') });
      if (!res){
        _this.outSrc = 'https://520ezj.com/jtzy/resources/01basis/fttid/control_library/0kanban/null_search.html';
        return;
      }else{
        _this.outSrc = ''
      }
    }
    // this.getContentIncomeByPfId()
    if(_this.getQuery('prevAppId')){
      _this.$http.get('/zciid-deliverable/showPlatformStyle/flow/api/get/getNameOrDiyPageName.json', {
        appId: _this.getQuery('prevAppId')
      }).then(res => {
        if(res.state == 1 && res.data){
          _this.znxgAppName = res.data.appName
        }
      })
    }
    if(_this.getQuery('brush')){
      //进入刷一刷页面
      _this.iframeSrc = 1;
      _this.thirdContent.state = 1;
    }
    _this.getSanbaoId();
    var arr = ['emailId','socialId','ywId','deviceId','exploitId'], userId = _this.$store.state.userInfo.userId ? _this.$store.state.userInfo.userId : localStorage.getItem('noLoginSid');
    if(!arr.filter((tag)=>_this.getQuery(tag)).length){
      _this.sanbaooperate = [{name:'首页',url:''},
        {name:'直接发布',url:'/zciid-deliverable/api/issue/siteWindowCreate?selectType=radiobox&userId='+ userId + '&pfId=' + window.$pfId},
        {name:'选择发布',url:'/zciid-deliverable/api/issue/siteWindowCreate?userId='+ userId + '&pfId=' + window.$pfId},
        {name:'一键发布',url:'/zciid-deliverable/api/issue/oneKeyList?userId='+ userId + '&pfId=' + window.$pfId},
        {name:'定向发布',url:'/zciid-deliverable/api/issue/orientList?userId='+ userId + '&pfId=' + window.$pfId}]
    }
    _this.getinfoName();
    // _this.$store.commit('showOther',false);
    //获取blockData
    
    var tid = _this.getQuery('pfId') || _this.getQuery('docId')|| _this.getQuery('productUrl')|| _this.getQuery('assetId') ||  _this.getQuery('socialId') || _this.getQuery('platformUrl') || _this.getQuery('id')||_this.getQuery('dataType') == 6;
      
    _this.getTitle(tid);
    if(!_this.forward){
      _this.getRelatedIntroduction();
      
      //链接有id
      if (_this.getQuery('id')) {
        _this.outSrc = '1';
        _this.getContentById();
      } else if (_this.getQuery('userId') && _this.getQuery('blockDataType') && _this.getQuery('blockId')) {
        _this.getContentByUserId();
      } else if (window.location.href.indexOf('thirdUrl') > -1) {
        _this.getIframe(_this.getQuery('thirdUrl'));
      } else if (window.location.href.indexOf('docId') > -1) {
        _this.getDocIdIframe(_this.getQuery('docId'));
      } else if (window.location.href.indexOf('productUrl') > -1) {
        _this.getProductUrlIframe(_this.getQuery('productUrl'));
      }else if (window.location.href.indexOf('socialId') > -1) {
        _this.getSocialIdUrlIframe(_this.getQuery('socialId'));
      } else if (window.location.href.indexOf('platformUrl') > -1) {
        _this.getplatformUrlIframe(_this.getQuery('platformUrl'));
      }else {
        _this.getContentByBlockId();
      }
      //获取展示方式
      _this.$http.get("/zciid-deliverable/api/abduction/getWzStandardTypeByContentId.json", {
        contentId: _this.$contentId
      }).then(res => {
        //接口是否请求完
        _this.finish = true;
        // if(res.state == 1 && res.data == 1){
        //   //相关推荐展示
        //   _this.Demonstrations = false;
        //   _this.$store.commit('isOrNotXgwz',true);
        // } 
        _this.$http
        .get('/zciid-deliverable/api/webapp/quote/get/display/type.json', {
            types: res.data ? 'displayType-media' : 'displayType-general',
            wzAppId: _this.getQuery('appId'),
            sixTypes: 'sign' + _this.getQuery('dataType')
          })
          .then((res) => {
            if (res.state == 1) {
              if (res.data == 'cmwz' || res.data == 'ftgt') {
                _this.Demonstrations = false;
                _this.$store.commit('isOrNotXgwz',true);
              }else{
                _this.Demonstrations = true;
              }
            }
          })
        })
      _this.$http.get("/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorDataSpit.json", {
        appId: _this.getQuery('appId'),
        domainNameType: document.location.pathname.split('/')[1]
      }).then(res => {
        if (res.state == 1) {
          if (_this.getQuery('floorflowId')) {
            var floorflowId = _this.getQuery('floorflowId');
            for (var i = 0; i < res.data.length; i++) {
              if (res.data[i].flowEnName == floorflowId || res.data[i].id == floorflowId) {
                _this.blockData = res.data[i];
                break;
              }
            }
            if(!Object.keys(_this.blockData).length){
              _this.blockData = res.data[res.data.length-1];
            }
          } else {
            _this.blockData = res.data[res.data.length-1];
          }
        }
      })
    }else{
      _this.finish = true;
    }
    
    if (!this.getQuery('dataType') && !this.getQuery('id')) {
      window.document.title = '社交智三宝';
    }
    //有参数
    if (window.location.search) {
      if ('pictures' in this.$route.query) {
        this.pictures = JSON.parse(this.$route.query.pictures);
        // this.index = JSON.parse(this.$route.query.ind);
        // this.$nextTick(()=>{
        //   this.adjustment();
        // })
      } else if ('video' in this.$route.query) {
        var ind = JSON.parse(this.$route.query.ind);
        this.video = JSON.parse(this.$route.query.video)[ind];
      } else if ('file' in this.$route.query) {
        this.file = JSON.parse(this.$route.query.file);
      } else if (window.location.search.indexOf('pfId') > -1&&!this.getQuery('assetId')) {
        this.showSlide = true;
      }
      
      this.$http.get('/cme-sso-app/product/info/get-smart-info', {
        pfId: window.$pfId,
        userId: this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : localStorage.getItem('noLoginSid'),
      }).then(res => {
        if (res.state == 1 && res.data) {
          var showUrl = res.data.sanbaoConfig&&res.data.sanbaoConfig.filter((tags) => tags.dataType == 'business_id').length ? res.data.sanbaoConfig.filter((tags) => tags.dataType == 'business_id')[0].configData : ''
          if (showUrl) {
            this.showUrl = showUrl
          }else{
            this.showUrl = res.data.ssoOpenid
          }
        }
      })
    } else {
      //无参数
      this.showSlide = true;
    }
    window.addEventListener('click', () => {
      _this.rightShow = false;
    })
    window.addEventListener('mousedown', (event) => {
      _this.rightShow = false;
      _this.flowShow = false;
    })
   
    Bus.$on('check', (params) => {
      _this.iframeSrc = params + (params.indexOf('?') > -1 ? '&' : '?') + 'time=' + Date.now();
    });
    _this.$nextTick(()=>{
      _this.Drags('.open');
    })
  },
  mounted () {
    var _this = this;
    var id = _this.$route.params.id;
    
    
    if(id == 'look'){
      _this.currentTab = 'deliverableDetailLook';
    }else if (id == 'chat'){
      _this.currentTab = 'deliverableDetailChat';
    }else{
      _this.currentTab = 'deliverableDetail'
    }
    if ( window.innerWidth <= 768) {
      _this.pageNum = 2;
    }
    if(_this.isFlowDetail){
      _this.initRightMenu({
        types: _this.rightType,
        appId: 'wzjfwzyzspt',
        frameType: 'show',
        permitUserId: _this.$store.state.userInfo.userId ? _this.$store.state.userInfo.userId : '',
        wzAppId: _this.getQuery('appId')
      });
    }
    
    if (!window.location.search || _this.getQuery('pfId') && !_this.getQuery('assetId') || _this.getQuery('docId')|| _this.getQuery('productUrl') ||  _this.getQuery('socialId') || _this.getQuery('platformUrl') || _this.getQuery('id')||_this.getQuery('brush')) {
      //解决屏幕宽度在786~1200时候出现滚动条问题
      var elm = document.getElementById('app');
      elm.setAttribute('style', 'width:100%');
    }
    _this.getSeckill(1, _this.pageNum);
    _this.getXgtjCon(1);
    if (document.getElementById('app').style.transform && $('.open')) {
      window.onscroll = function () {
        var t = document.documentElement.scrollTop || document.body.scrollTop;
        var scale = document.getElementById('app').style.transform.slice(6, -1);
        var visibleTop = t / scale;
        $('.open').css('bottom', window.$bottom - (visibleTop - (window.$scrollTop ? window.$scrollTop : 0)));
      }
    }
    Bus.$on('dianzaiFanxian', (t, b) => {
      _this.initData.like = t;
      _this.initData.likeNum = b;
    })
    Bus.$on('shoucangFanxian', (t, b) => {
      _this.initData.collect = t;
      _this.initData.collectNum = b;
    })
    Bus.$on('changeIfameUrl',(t,b)=> {
      // this.iframeSrc = t + (t.indexOf('?') > -1 ? '&' : '?') + 'time=' + Date.now();
      //弹窗
      layer.open({
        type: 2,
        title: b,
        closeBtn: 1,
        area: ['100%', '100%'],
        content: t //iframe的url
      })
    })
    //中机知道标题替换左上角名称
    // Bus.$on('changeName', t => {
    //   this.getTitle(this.$contentId, t);
    // });
    
    window.onmessage = function (e) {
      var e = e || window.event;
      var url = encodeURIComponent(window.location.href);
      //同源域名触发
      if (!_this.getQuery('dataType') && e.origin == window.location.origin) {
        _this.shareUniversal(e, url, '', '', '');
      }
    }
    this.$http.get("/acnid-project-approve/api/process/qrcode/record/save", {
      qrcodeType: 'subordinate',
      dataId: this.getQuery('uid'),
      codeScanner: this.userId,
      behavior: 'scan',
      appId: this.getQuery('sbAppId')
    }).then(()=>{
      this.centerHeight = window.innerHeight - ($('.navbars').length ? $('.navbars').height() : 0) - $('.bottom').outerHeight() - 1 + 'px';
      this.isLoading = false;
    })

  },
  provide() {
    return {
      seckill:true,
      member:true,
      fatherMethod: this.showNoResults
    }
  },
  activated () {
    // 重置下拉滚动条的状态
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  beforeDestroy() {
    Bus.$off('changeIfameUrl');
  },
  watch: {
    '$store.state.setContentIds': function (val) {
      if (val.contentIds == this.$store.state.setInitData.content) {
        this.initData = this.$store.state.setInitData.data;
      }
    },
    '$store.state.setInitData': function (val) {
      if (val.content == this.$store.state.setContentIds.contentIds) {
        this.initData = val.data;
      }
    },
    '$store.state.userInfo': function (val) {
      if (val) {
        this.sendMessage();
      }
    },
    '$store.state.winWidth': function(val){
      this.centerHeight = window.innerHeight - ($('.navbars').length ? $('.navbars').height() : 0) - $('.bottom').outerHeight() - 1 + 'px';
      this.$refs.scrollDom ? this.scrollWidth = this.$refs.scrollDom.clientWidth : '';
    },
    '$store.state.winHeight': function(val){
      this.centerHeight = window.innerHeight - ($('.navbars').length ? $('.navbars').height() : 0) - $('.bottom').outerHeight() - 1 + 'px';
    },
    odzidName: function (val) {
      this.sendMessage();
      if (!this.isFlowDetail) {
        this.weixinShare(val, this.theme);
      }
    },
    '$store.state.noLoginSid': function (newVal,oldVal) {
      if (!oldVal && newVal) {
        this.metaMeet()
      }
    },
  },
  computed: {
    detail(){
      //刷一刷页面在预览页嵌套时不显示小元在线
      return parent.location.hostname.indexOf('/uoqid/detail') > -1
    },
    cwdl(){
      //成为代理
      return location.origin + '/zjstatic/standard/project/outreach/becomeAgent.html?userId=' + this.userId
    },
    jrzx(){
      //加入直销
      return `${location.origin}/zjstatic/standard/project/kehuduan_page/tuiguang.html?pfId=${this.getQuery('prevPfId') ?this.getQuery('prevPfId') : window.$pfId}&userId=${this.userId}&wzAppId=${(this.getQuery('prevAppId') ?this.getQuery('prevAppId') : this.$appId )}&merchantName=${(this.getQuery('prevMerchantName') ?this.getQuery('prevMerchantName') : (window.$contentData &&  window.$contentData[0].appName ? window.$contentData[0].appName : '自营商城'))}&hasLogin=${this.$store.state.userInfo.userId ? 1 : ''}&payPfId=${window.$pfId}`
    },
    cwznxg(){
      //成为智能新贵
      return location.origin + '/zjstatic/standard/project/outreach/outreach_form.html?pfId=' + (this.getQuery('prevPfId') ?this.getQuery('prevPfId') : window.$pfId) + '&userId=' + this.userId + '&wzAppId=' +  (this.getQuery('prevAppId') ?this.getQuery('prevAppId') : this.$appId ) + '&merchantName=' + (this.znxgAppName ?this.znxgAppName : (window.$contentData &&  window.$contentData[0].appName ? window.$contentData[0].appName : '自营商城'))+ '&hasLogin=' + (this.$store.state.userInfo.userId ? 1 : '') + '&payPfId=' + window.$pfId
    },
    rightContent(){
      return !this.topShow || this.forward ? (this.rightMenus.filter(tag=>(!(tag.menuName=='加入购物车'||tag.menuName=='购物车'||tag.menuName=='订单管理'||tag.menuName=='操作工具'||tag.menuName=='粉丝发布')))):this.rightMenus.filter(tag=>(tag.menuName!='粉丝发布'))
    },
    isPC () {
      if (window.innerWidth > 768 ) {
        return true;
      } else { return false; }
    },
    newDetail () {
      if ((self != top) && (this.getQuery('isYyz') === 1 || this.getQuery('isYyz') === 0)) {
        return false;
      } else {
        return true;
      }
    },
    isFlowDetail () {
      if (this.getQuery('dataType') || window.location.href.indexOf('blockId') > -1 || this.forward) {
        return true;
      } else {
        return false;
      }
    },
    specialTop(){
      return this.getQuery('showMore') || this.getQuery('hideTop')
    },
    userId () {
      return this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : (this.getQuery('localUserId') ? this.getQuery('localUserId') : this.$store.state.noLoginSid)
    },
    userName () {
      return this.$store.state.userInfo.userName ? this.$store.state.userInfo.userName : (this.getQuery('localUserId') ? this.getQuery('localUserId') : this.$store.state.wxud)
    },
    hasLogin () {
      return (this.$store.state.userInfo.id || this.$store.state.userInfo.userId);
    },
    outermost () {
      return self == top && !this.IsApp().APP
    }
  },
  methods: {
    scroll(add){
      var box = document.querySelector('.tab-change');
      var x1,x2,l,flag,left; 
      function down(){
        flag = true;
        var e = window.event
        x1 = e.touches ? (e.touches[0].pageX) : e.clientX;
        left = parseInt(box.style.marginLeft) ? parseInt(box.style.marginLeft) : 0;
      }
      function move(){
        if(flag){
          var e = window.event
          x2 = e.touches ? (e.touches[0].pageX) : e.clientX;
          // 计算left
          l = x2 - x1 + left;
          if(l > 0){
            l = 0;
          }
          if(l<box.parentNode.offsetWidth - box.offsetWidth){
            l = box.parentNode.offsetWidth - box.offsetWidth + 8;
          }
          if(box.offsetWidth - box.parentNode.offsetWidth < 0) return;
          box.style.marginLeft = l + 'px';
        }
      }
      function end(){
        flag = false;
      }
      if(add){
        box.addEventListener("touchstart", down);
        box.addEventListener("touchmove", move);
        box.addEventListener("touchend", end);
      }else{
        box.removeEventListener("touchstart", down);
        box.removeEventListener("touchmove", move);
        box.removeEventListener("touchend", end);
      }
    },
    qldMore(){
      this.$nextTick(()=>{
        this.scrollWidth = this.$refs.scrollDom.clientWidth;
        this.scroll(this.qldShow ? 'add' : '')
      })
    },
    changeLeftFn(){
        if(this.speed == 0){
            return false;
        }
        this.speed++;
        this.marginLeft = this.speed * 150 > 0 ? this.speed * 150 : 0;
    },
    changeRightFn(){
        if(this.tabCalc + this.marginLeft < this.scrollWidth){
            return false;
        }
        this.speed--;
        this.marginLeft = this.speed * 150 > (this.scrollWidth - this.tabCalc) ? this.speed * 150 : (this.scrollWidth - this.tabCalc);
    },
    // changeOdzidName(name){
    //   this.odzidName = name;
    // },
    knowMore(){
      layer.open({
        type: 2,
        title: '了解更多',
        closeBtn: 1,
        area: ['100%', '100%'],
        content: location.origin + '/meeting-tool-web/sso/live/index' + (this.$store.state.isLogin && this.getCookie('cmeAppToken') ? '?cmeAppToken=' + this.getCookie('cmeAppToken') + '&' : '?') + 'takeGoods=1&platId=' + window.$pfId
      })
    },
    // getContentIncomeByPfId(){
    //   this.$http
    //     .get("/zciid-deliverable/api/content/getWzConnectIncomeByContentId.json", {
    //       contentId: this.$contentId,
    //       appId: this.$appId
    //   }).then(res => { 
    //     if(res.state == 1 && res.data.length){
    //       this.haveCartData = res.data.length
    //     }
    //   })
    // },
    hoversTwoShowFun(num){
      switch (num){
        case 0 : 
          this.contents = [{name:'一键更新',link:'/zciid-deliverable/grab/start/edit?dataType=issueUpdate&id=#contentId&userId=#userId&userName=#userName&pfId=#pfId'},{name:'连载更新',link:'/zciid-deliverable/grab/start/edit?dataType=serialUpdate&id=#contentId&userId=#userId&userName=#userName&pfId=#pfId&openIssueType=none'},{name:'一键删除',link:'/zciid-deliverable/api/third/issue/oneKeyDelete?openType=issue&meetType=&communicationId=&pfId=#pfId&userId=#userId&contentId=#contentId&contentName=#contentName&openIssueType=none'}]
          break
        case 1 : 
          this.contents = [{name:'快速会议',link:'/meeting-tool-web/fast/meet/to-save?transmitType=circle&platId=#pfId'},{name:'同屏统计',link:'/meeting-tool-web/meeting/circle/meet/list?pfId=#pfId'}]
          break
      }
      this.hoversTwoShow = true;
      $('.open .hoversTwo').show();
    },
    suspendEnter (item) {
      this.changOption(item.link,item.name)
    },
    openMainToolsiframe(){
      var url = location.origin + ((location.hostname.indexOf('520ezj.com') > -1 || location.hostname.indexOf('520emv.com') > -1) ? '/caasid/facility/list?sift=5&isTop=true' : '/caasid/facility/list?sift=2&isTop=true');
      this.jumpUrl({'url':url});
      this.selectDes = false;
    },
    hiddenFloor(type){
      this.Name4[this.Name4.findIndex(obj => obj.enName == type)].showOrFalse = false;
    },
    getSanbaoId(){
      this.$http
        .get("/aassid/cms/client/api/getAppIdByPfId.json", {
          pfId: this.pfId
      }).then(res => {  
        if(res.state == 1){
          this.sanbaoId = res.data;
          }
        this.initRightMenu({
          types: 82,
          appId: 'odzid' + ((location.hostname.indexOf('520ezj') == -1 && location.hostname.indexOf('cmeplaza') == -1)? this.sanbaoId : ''),
          frameType: 'meta',
          permitUserId: this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : ''
        },'top');
      })
    },
    showNoResults(t){
      if(t){
        this.cont.push(t);
      }
      if(this.cont.length){
        this.noResults = false; 
      }else{
        this.noResults = true; 
      }
    },
    //获取下拉框内容
    getinfoName(){
      this.$http.get("/aassid/cms/client/api/platform/sanbaolistnew.json", {
        userId: this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : '',
        appId:this.getQuery('appId'),
        pfId: this.pfId,
        appType:'com.cmeplaza.intelligent.preview'
      }).then(res => {
        if(res.state == 1){
          this.infoName = res.data;
        }
      })
    },
    // hideXiaoYuan(){
    //   if($('.hovers').is(':visible')){
    //     $('.hovers').hide();
    //   }else{
    //     $('.hovers').show();
    //   }
    // },
    getRelatedIntroduction(){
      this.$http
        .get("/zciid-deliverable/api/briefConfig/getList.json", {
          mainType: this.$contentId
      }).then(res => {  
        if(res.state == 1){
          this.relatedIntroduction = res.data;
        }
      })
    },
    jumpWzUrl(item){
      if(item.contentWzUrl || item.url){
        window.open(item.contentWzUrl || item.url,'_self');
      }
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getXgtjCon(1);
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getXgtjCon(val);
    },
    getXgtjCon(size){
      var url = "/zciid-deliverable/api/showPlatform/content/getWzMediaRecommend.json",data={appId: this.$appId,contentId:this.$contentId,pfId:window.$pfId,userId:this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : ''};
      this.$http
        .get(url, data).then(res => {
          if(res.state == 1){
            // if(this.Xgtypes == 'gzkh'){
              res.data ? (this.xgwzContent = res.data) : (this.xgwzContent = []);
            // }
            
            
          }
      })
    },
    //左移右移
    leftRightMove (ind,that,ite) {
      const item = ite;
      window.$item = item;
      window.$nodeId = item.nodeId;
      window.$contentWzUrl = item.contentWzUrl ? item.contentWzUrl : item.contentDsfWzUrl;
      var left = {}, center = {}, right = {};
      if (item && item.contentId || this.dataAssetId) {
        center = {
          item: item,
          blockId: item.blockId,
          contentId: item.contentId,
          contentShowRowsSort: ind,
          standardJson: item.tags
        }
      }

      var rightLeft = {
        left: left,
        center: center,
        right: right
      }

      window.$rightLeft = rightLeft;
      this.rightShow = true;
    },
    getSeckill(size,num){
      var _this = this;
      var url = "/zciid-deliverable/showPlatformStyle/flow/api/getConfigContentByAppId.json",
      data = {appId: _this.$appId,pageNum: size,pageSize: num,types:this.types,supContentId:this.$contentId};
      if(_this.types == 'zycp'){
        //主营产品单独处理
        url = "/zciid-deliverable/api/showPlatform/content/getFlowContentByBlockId.json";
        data = {appId: _this.$appId,blockId:_this.getQuery('blockId'),pageNum: size,pageSize: num};
      }
      _this.$http
        .get(url, data).then(res => {
          if (res.state == 1 && res.data.length) {
            var array = [];
            res.data.forEach((item) => {
              var tags = [], pictures = [], others = [], btns = [], contentId = '', blockId = '';
              contentId = item.contentId;
              blockId = item.blockId;
              item.standardJson.forEach((ele) => {
                if (ele.standardData && (ele.standardData.indexOf('.mp4') > 0 || ele.standardData.indexOf('.png') > 0 || ele.standardData.indexOf('.jpg') > 0 || ele.standardData.indexOf('.jpeg') > 0)) {
                  pictures.push(ele.standardData);
                } else {
                  others.push(ele);
                }
              })

              array.push({
                appId:item.appId,
                appName:item.appName,
                contentId: contentId,
                blockId: blockId,
                nodeId: item.nodeId,
                pictures: pictures,
                others: others,
                btns: btns,
                sign: item.sign,
                tags: item.standardJson,
                endTime: item.endTime,
                discountTypes: item.discountTypes,
                priceType: item.priceType,
                changeData: item.changeData,
                spellData: item.spellData,
                spellText: item.spellText,
                giveData: item.giveData,
                giveText: item.giveText,
                ordinaryPrice: item.ordinaryPrice,
                silverPrice: item.silverPrice,
                goldprice: item.goldprice,
                platinumPrice: item.platinumPrice,
                diamondsPrice: item.diamondsPrice,
                blackGoldprice: item.blackGoldprice,
                memberEndTime: item.memberEndTime
              })
            })
            _this.contentData.push(...array);
          }
        })
    },
    changeBut(ind,item){
      this.contentData = [];
      this.blockDataId ={'id':item.id};
      this.types = item.enName;
      this.getSeckill(1,5);
    },
    changeBut1(ind){
      this.pingjia = ind;
    },
    changeBut2(ind,item){
      this.Xgtypes = item.enName;
      this.getXgtjCon(1);
    },
    handleExpandChange (data) {
      this.rightAreaChange(data, this.rMenuPos.left);
    },
    sendMessage () {
      if (!this.isFlowDetail && this.$store.state.userInfo.userId) {
        var array = ['onqid', 'oamid', 'odzid', 'zkzkid'];
        this.$http.get("/zciid-deliverable/interface/deliverables/send/grab/message", {
          userId: this.$store.state.userInfo,
          id: this.getQuery('thirdUrl') || this.getQuery('id') || this.getQuery('docId') || this.getQuery('productId'),
          title: this.odzidName,
          url: window.location.href,
          messageType: array.filter((tags) => window.location.href.indexOf(tags) > -1)[0]
        })
      }
    },
    jumpUrl (item) {
      if(!this.contentName){
        //记录交付物名称
        this.contentName = $('.mainTitle').length ? $('.mainTitle')[0].innerText : $('.textTit span').length ? $('.textTit span')[0].innerText : ''
      }
      var contentId = this.$contentId;
      if(!item.url){
        this.open(window.location.origin + '/aassid','_blank')
      }else{
        if(['直接发布','选择发布','一键发布'].includes(item.name)&& contentId&& item.url.indexOf('contentName')<0){
          item.url += '&contentId=' + contentId + '&contentName=' + this.contentName
        }
        this.iframeSrc = item.url;
        this.thirdContent.state = 0;
      }
    },
    hideSel(){
      //点击右侧按钮收起下拉框
      this.selectDes = false;
    },
    //点击出现下拉框，并获取焦点
    selectDesp () {
      this.selectDes = !this.selectDes;
      if(this.$refs.sonHtml){
        this.$refs.sonHtml.hideSelect();
      }
      setTimeout(() => {
        this.$refs.input_des.focus();
      }, 100)
    },
    specialTreatment (sendData) {
      if (navigator.userAgent.indexOf('Electron') > -1) {
        var ipcRender = top.window.ipcRender ? top.window.ipcRender : top.window.require('electron').ipcRenderer;
        //发送指令
        try {
          ipcRender.send('openWindow', { 'title': ZNname, 'url': sendData.wzUrl });
        }
        catch (e) {
          console.log("不支持ipcRenderer");
        }
      } else {
        this.open(sendData.wzUrl,'_self',sendData.name);
      }
    },
    async getTitle (tid, t) {
      var defaultTitle = '';
      if (this.getQuery('docId')) {
        defaultTitle = '我的工作';
      } else if (this.getQuery('platformUrl')) {
        defaultTitle = this.getQuery('professionName');
      }else if (this.getQuery('pfId')) {
        defaultTitle = '社交智三宝';
      } else if (t) {
        defaultTitle = t;
      }
      if(this.getQuery('appName')){
        defaultTitle = this.getQuery('appName');
      }
      var res,resq,userId=this.getQuery('nowReceiveId') ? this.getQuery('nowReceiveId') : this.$store.state.userInfo.userId;
      if(userId) {
        res = await this.$http.get('/zciid-deliverable/api/shell/selectOne.json', {
          dataId: tid||this.$contentId,
          userId: userId
        });
      }
      
      if(this.isFlowDetail){
        //在详情页
          resq = await this.$http.get('/zciid-deliverable/showPlatformStyle/flow/api/get/getContentByIdAndStandardId.json', { contentId: this.$contentId });
          this.jumpLink = resq && resq.state && resq.data.floatInterface ? resq.data.floatInterface : ''
          console.log(resq.data);
          
          this.publish = resq.data
      }
      this.odzidName =  this.getQuery('assetId') ?  ($('.textTit span').length ? $('.textTit span')[0].innerText : '') : (res && res.data && res.data.title ? res.data.title :  (resq && resq.state && resq.data.pfName ? resq.data.pfName : (defaultTitle ? defaultTitle:'传媒智人')));
      this.imgages = res && res.data && res.data.logo ? (window.location.origin + '/cme-sso-app/showimg/' + JSON.parse(res.data.logo)[0].id) : require('../assets/image/images/abduction_zsb.png')
      this.theme = res && res.data && res.data.theme ? res.data.theme : '';
      this.backGroundCol = res && res.data && res.data.background ? res.data.background : '';
      window.document.title = this.odzidName;
    },
    getDocIdIframe (url) {
      this.iframeSrc = this.$store.state.baseURL + '/cme-sso-app/im/sharing/init-table-page?docId=' + url;
    },
    getProductUrlIframe (id) {
      this.iframeSrc = this.$store.state.baseURL + '/zciid-deliverable/app/api/product/showDetail?id=' + id;
    },
    getSocialIdUrlIframe (id) {
      this.iframeSrc = this.$store.state.baseURL + '/zciid-deliverable/api/abduction/triratna/selectInfo?id=' + id + '&isOr=true';
    },
    getplatformUrlIframe (id) {
      this.iframeSrc = this.$store.state.baseURL + '/acnid-project-approve/send/instruct/preview?id=' + id;
    },
    getIframe (url) {
      var that = this;
      that.$http.get("/zciid-deliverable/api/webapp/quote/get/api/app/info.json", {
        id: url
      }).then(res => {
        if (res.state == 1) {
          that.iframeSrc = res.data.wzUrl;
          that.thirdContent = res.data;
          that.$http.get("/zciid-deliverable/api/shell/selectOne.json", {
            dataId: url,
            userId: that.getQuery('nowReceiveId') ? that.getQuery('nowReceiveId') : that.$store.state.userInfo.userId
            }
          ).then(req=>{
            that.odzidName = req.data && req.data.title ? req.data.title : res.data.name;
            that.imgages = req.data && req.data.logo ? (that.$store.state.baseURL + '/cme-sso-app/showimg/' + JSON.parse(req.data.logo)[0].id) : require('../assets/image/images/abduction_zsb.png');
            that.theme = req.data && req.data.theme ? req.data.theme : '';
            that.backGroundCol =  req.data && req.data.background ? req.data.background : '';
          })
            
      
          if ((navigator.userAgent.indexOf('Electron') == -1 || (navigator.userAgent.indexOf('Electron') > -1 && !that.getQuery('isClient'))) && res.data.state) {
            var area = window.location.href.indexOf('520ezj') > -1 ? true : false;
            $.ajax({
              url: 'http://localhost:' + (area ? '3002' : '3001') + '/check/server',
              timeout: 1000,
              type: 'get',
              dataType: 'json',
              success: function (data) {
                $.ajax({
                  url: 'http://localhost:' + (area ? '3002' : '3001') + '/open/window',
                  type: 'get',
                  data: { url: window.location.href, title: res.data.name },
                  dataType: 'json'
                });
              },
              complete: function (XMLHttpRequest, status) {
                if (status == 'timeout') {
                  window.location.href = (window.location.href.indexOf('520ezj') > -1 ? 'zjsclient' : 'znrclient') + '://open?title=' + res.data.name + '&url=' + window.location.href;
                }
              }
            });
          }
          setTimeout(() => {
            //解决Electron中的webview标签,对a标签target=“_blank”属性的拦截
            const webview = document.getElementById("targetSite");
            const iframe = document.getElementById("deliverable");
            if (webview) {
              webview.addEventListener("new-window", (e) => {
                e.preventDefault();
                const urlClass = new URL(e.url);
                const { protocol } = urlClass;
                if (protocol === "http:" || protocol === "https:") {
                  webview.src = e.url;
                }
              });
            }
            if (iframe && navigator.userAgent.indexOf('Electron') > -1) {
              var ipcRender = top.window.ipcRender ? top.window.ipcRender : top.window.require('electron').ipcRenderer;
              ipcRender.on('iframeUrl', (event, info) => {
                iframe.src = info.url;
              })
            }
          }, 300)
        }else{
          that.iframeSrc = 'about;blank';
        }
      })
    },
    reloads () {
      if(this.isFlowDetail){
        this.open(this.jumpLink,'_blank')
      }else{
        window.location.reload();
      }
    },
    //点赞
    changOption (link,name) {
      var url = location.origin + this.replaceDataByWell(link)
      layer.open({
        type: 2,
        title: name,
        closeBtn: 1,
        area: ['100%', '100%'],
        content: url //iframe的url
      })
    },
    liNewHoverFunEnter (data) {
      this.changeData(data);
    },
    getUrl (ind) {
      var startUrl = '',pinglunContent = this.$store.state.setContentIds,
        _this = this;
      // if (ind == 0) {
      //   startUrl = _this.$store.state.baseURL + '/zciid-deliverable/interface/deliverables/transmit/circle/list?contentId=';
      // } else if (ind == 1) {
      //   startUrl = _this.$store.state.baseURL + '/zciid-deliverable/interface/deliverables/transmit/user/list?contentId=';
      // } else if (ind == 3) {
      //   var link;
      //   link = _this.$store.state.baseURL + '/zciid-deliverable/api/issue/issueApp?issueType=8&contentIdStr='+ _this.$contentId +'&contentIdStrName='+ pinglunContent.titleCont +'&userId='+ pinglunContent.userId +'&userName=' + pinglunContent.userName + '&pfId=' + window.$pfId + '&appId=' + pinglunContent.appId;
      //   return link;
      // }
      
      // var url = startUrl + pinglunContent.contentIds + '&creatUserId=' + pinglunContent.otherDatas.userId + '&creatUserName=' + pinglunContent.otherDatas.userName + '&userId=' + pinglunContent.userId + '&userName=' + pinglunContent.userName + '&photo=' + pinglunContent.photo + '&transmitUrl=' + encodeURIComponent(_this.getQuery('dataType') ? window.location.href : window.location.href.replace('flowDetail', 'odzid') + '&dataType=' + pinglunContent.dataType) + '&stanardByAppNameData=' + pinglunContent.otherDatas.stanardByAppNameData + '&stanardByMainFigureData=' + pinglunContent.otherDatas.stanardByMainFigureData + '&stanardByBasicPriceData=' + pinglunContent.otherDatas.stanardByBasicPriceData + '&stanardByVideoShowData=' + pinglunContent.otherDatas.stanardByVideoShowData + '&pfId=' + window.$pfId;
      // if(ind == 1){
      //   url = startUrl + pinglunContent.contentIds + '&creatUserId=' + pinglunContent.otherDatas.userId + '&creatUserName=' + pinglunContent.otherDatas.userName + '&userId=' + pinglunContent.userId + '&userName=' + pinglunContent.userName;
      // }

      
      if(ind){
        startUrl = _this.$store.state.baseURL + '/zciid-deliverable/api/issue/socialAnewIssue?anew=anew&pfId='+ window.$pfId +'&userId='+ pinglunContent.userId +'&contentId=' + pinglunContent.contentIds + '&contentName=' + pinglunContent.titleCont;
      }else{
        startUrl = _this.$store.state.baseURL + '/zciid-deliverable/grab/start/edit?id=' + pinglunContent.contentIds;
      }
      return startUrl;
    },
    suspendLeave () {
      // this.iframeUrl = '';
      this.suspendShow = false;
    },
    //打开layer弹窗
    async openLayerWin (num) {
      var img = !this.iframeSrc&&!this.showSlide,userArr= this.$store.state.CreatorInformation.length ? this.$store.state.CreatorInformation : [],createdId= userArr.length ? userArr[0].userId : '',contentIndex= window.$contentIndex ? window.$contentIndex : 0,wxud=localStorage.getItem('wxud') || '',noLoginSid = localStorage.getItem('noLoginSid') || '',_this=this;
      var pfId = _this.getQuery('pfId') ? _this.getQuery('pfId') : window.$pfId,nowReceiveId = _this.getQuery('nowReceiveId'),titleName=$('.textTit span').length ? $('.textTit span')[0].innerText : ($('.mainTitle')[contentIndex] && $('.mainTitle')[contentIndex].innerText ? $('.mainTitle')[contentIndex].innerText : '');
      var contentId = (_this.$contentId ? _this.$contentId : (_this.getQuery('id') ? _this.getQuery('id') : (document.querySelector('#deliverable')&&document.querySelector('#deliverable').contentWindow.document.querySelector("input[name='contentId']") ? document.querySelector('#deliverable').contentWindow.document.querySelector("input[name='contentId']").getAttribute("value") : '')));
      if(['immediate','voice','def','organization'].includes(num)){
        
        if(num != 'organization'){
          var userId = _this.$store.state.userInfo.userId ? _this.$store.state.userInfo.userId : '';
          if(userId && img){
            _this.$http.get("/zciid-deliverable/api/app/joinCircle", {
              id: _this.$contentId,
              userId: userId
            })
          }
        }
        
      }
      switch (num) {
        case 'register':
          _this.register('tabChangePage');
          break;
        case 'login':
          _this.handleLoginAuth();
          break;
        case 'handleLogout':
          _this.handleLogout();
          break;
        case 'Chatbot':
          _this.openLayer('聊天机器人',_this.$store.state.baseURL + '/im/chat/chatbot');
          break;
        case 'immediate':
          // if (img && !window.click_debug) return;
          var link = _this.$store.state.baseURL + '/im/kf?appId=' + _this.getQuery('appId') + '&deliverableName=' + titleName + '&contentId=' + contentId + '&flowId=' + _this.getQuery('blockId') + '&receiveId=' + (img ? createdId : nowReceiveId) + '&userId=' + (_this.$store.state.userInfo.userId ? _this.$store.state.userInfo.userId : noLoginSid) + '&wxud=' + wxud + '&pfId=' + pfId;
            _this.openLayer('即时通讯', link);
          break;
        case 'voice':
          if (img) {
            nowReceiveId = createdId;
          }
          if(_this.IsApp().APP){
            _this.postToApp({
              "handleName":"videoCallJump",
              "params":{
              'callType':1,
              'friendId':nowReceiveId,
              'friendIcon':'',
              'friendName':'',
              'imporType':(img ? 1 : 2),
              'contentId':img ? _this.$contentId : window.$cid,
              'Domain': location.origin,
              'pfId':window.$pfId
              }
            });
            return;
          }
          _this.getSpecialUrl('182', '语音通讯', nowReceiveId, titleName,userArr,wxud,noLoginSid);
          break;
        case 'def':
          if (img) {
            nowReceiveId = createdId;
          } 
          if(_this.IsApp().APP){
            _this.postToApp({
              "handleName":"videoCallJump",
              "params":{
              'callType':2,
              'friendId':nowReceiveId,
              'friendIcon':'',
              'friendName':'',
              'imporType':(img ? 1 : 2),
              'contentId':img ? _this.$contentId : window.$cid,
              'Domain': location.origin,
              'pfId':window.$pfId
              }
            });
            return;
          }
          _this.getSpecialUrl('183', '视频通讯', nowReceiveId, titleName,userArr,wxud,noLoginSid);
          break;
        case 'screen':
          if (img) {
            _this.openLayer('业务同屏', _this.$store.state.baseURL + '/meeting-tool-web/communication/assistant/communication?appId=' + _this.getQuery('appId') + '&flowId=' + _this.getQuery('blockId') + '&cType=185');
          } else {
            _this.getSpecialUrl('184', '业务同屏');
          }
          break;
        case 'organization':
            if(_this.$store.state.userInfo && _this.$store.state.userInfo.userId && _this.$store.state.userInfo.userId == nowReceiveId ){
                layer.msg("当前人为自己，无法同屏");
              return;
            }
            var array = ['ywId','deviceId','socialId','emailId'].filter((tags) => location.href.indexOf(tags) > -1);
            _this.$http.get("/meeting-tool-web/interface/meeting/chat/meet.json", {
              userId: _this.$store.state.userInfo.userId ? _this.$store.state.userInfo.userId : noLoginSid,
              userName: _this.$store.state.userInfo.trueName ? _this.$store.state.userInfo.trueName : wxud,
              receiveId: img ? createdId : nowReceiveId,
              // dataId: img ? '' : (array.length ? _this.getQuery(array[0]) : ''),
              // appId:_this.$appId,
              // commuType: 'zztp',
              pfId: pfId,
              deliverableName: titleName,
              kfctype: 4,
              message: '同屏通讯',
              contentId:_this.$contentId ? _this.$contentId :'',
              userCode: _this.$store.state.userInfo.userId ? '' : wxud

            }).then(res => {
              //当前用户进入通讯页面
              if(res.state > 0&&res.data.url){
                var url = res.data.url;
                _this.openLayer('同屏通讯', url+'&wxud='+wxud);
              }
            })
          break;
        case 'commerce':
          _this.openNewUrl('带货同屏',  _this.$store.state.baseURL + '/meeting-tool-web/sso/live/index?platId=' + pfId+'&userId='+(_this.$store.state.userInfo.userId ? _this.$store.state.userInfo.userId :'')+
        '&userName='+(_this.$store.state.userInfo.trueName ? _this.$store.state.userInfo.trueName : '')+
        '&receiveId='+_this.getQuery('nowReceiveId')+'&takeGoods=1');
          break;
      }
    },
    openNewUrl (name, authorizeUrl) {
      this.open(authorizeUrl,'','','',name);
    },
    getContentById () {
      this.$http.get("/zciid-deliverable/showPlatformStyle/flow/api/getWzUrlByReleaseId.json", {
        releaseId: this.getQuery('id')
      }).then(res => {
        if (res.state == 1) {
          this.outSrc = res.data;
          location.href = res.data;
        }
        if (res.state == 2) {
          this.startIframe = res.data;
        }
        if (res.state == 3) {
          this.endIframe = res.data;
        }
      })
    },
    getContentByUserId () {
      this.$http.get("/zciid-deliverable/showPlatformStyle/flow/api/getYuanUniverseUrlByBlockDataType.json", {
        userId: decodeURIComponent(this.getQuery('userId')),
        blockDataType: this.getQuery('blockDataType'),
        blockId: this.getQuery('blockId'),
        appId: this.getQuery('appId')
      }).then(res => {
        if (res.state == 1) {
          this.iframeSrc = res.data;
        }
      })
    },
    getContentByBlockId () {
      this.$http.get("/zciid-deliverable/showPlatformStyle/flow/api/getCheckRightButtonByAppId.json", {
        appId: this.getQuery('appId')
      }).then(res => {
        var _this = this;
        var data = res.data ? res.data : [];
        _this.showName = JSON.parse(JSON.stringify(data));
        switch (parseInt(_this.getQuery('dataType'))) {
          case 1:
            _this.Name = data;
            _this.Name.unshift({ detailName: '智者说' });
            _this.Name.push({ detailName: '商品评价' });
            break;
          case 2:
            _this.Name = data;
            _this.Name.unshift({ detailName: '抖变视界' });
            _this.Name.push({ detailName: '商品评价' });
            break;
          // case 3:
          //   _this.Name = data;
          //   _this.Name.unshift({ detailName: '抖变世界' });
          //   _this.Name.push({ detailName: '商品评价' });
          //   break;
          // case 4:
          //   _this.Name = data;
          //   _this.Name.unshift({ detailName: 'ZJ同屏' });
          //   _this.Name.push({ detailName: '商品评价' });
          //   break;
          // case 5:
          //   _this.Name = data;
          //   _this.Name.unshift({ detailName: '同屏体验' });
          //   _this.Name.push({ detailName: '商品评价' });
          //   break;
          case 6:
            _this.Name = data;
            _this.Name.unshift({ detailName: '智能直播' });
            _this.Name.push({ detailName: '商品评价' });
            break;
          case 7:
            _this.Name = data;
            _this.Name.unshift({ detailName: '今日资讯' });
            _this.Name.push({ detailName: '商品评价' });
            break;
          case 8:
            _this.Name = data;
            _this.Name.unshift({ detailName: '智能文库' });
            _this.Name.push({ detailName: '商品评价' });
            break;
          // case 9:
          //   _this.Name = data;
          //   _this.Name.unshift({ detailName: '操作培训' });
          //   _this.Name.push({ detailName: '商品评价' });
          //   break;
          case 10:
            _this.Name = data;
            _this.Name.unshift({ detailName: 'AI设备' });
            _this.Name.push({ detailName: '商品评价' });
        }
        var a = JSON.parse(JSON.stringify(_this.Name));
        _this.oneName = a.shift();
        _this.lastName = a.pop();
        _this.sdgka = a;
      })
    },
    touchstarts (ev,show,top) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.windowRightMenu(ev,show,top);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmoves: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchends: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    //关闭iframe页面，返回页面展示
    goback (item) {
      if (self == top && navigator.userAgent.indexOf('Electron') > -1&&item == 'close') {
        //在客户端并且是最外层
        var ipcRender = top.window.ipcRender ? top.window.ipcRender : top.window.require('electron').ipcRenderer;
        ipcRender.send('close');
        return;
      }
      if(item == 'close'){
        //在浏览器或客户端自定义
        //加参数的跳地址
        //不加参数空白
        // if(location.search.indexOf('appId=') > -1 || location.search.indexOf('id=') > -1){
        //   window.history.back();
        // }else if(!location.search || this.getQuery('pfId')){
        //   location.href="about:blank;";
        // }else{
        //   location.href = location.origin + '/odzid';
        // }
        if(location.search.indexOf('appId=') > -1 || location.search.indexOf('id=') > -1){
          window.history.back();
        }else{
          location.href = "about:blank;";
        }
        return;
      }
      const webview = document.getElementById("targetSite");
      if (item == 'back' && webview) {
        webview.goBack();
        return;
      }
      if (item == 'back' && this.getQuery('dataType') && this.iframeSrc) {
        // 详情页
        this.iframeSrc = '';
        return;
      }
      if (item == 'back') {
        this.$http.get("/aassid/cms/client/api/getHangAppIds.json", {
          navCode:'znsq',
          pfId:window.$pfId
        }).then(res => {
          if (res.state == 1 && res.data) {
            location.href = location.origin + '/uoqid/?appId=' + res.data
          }
        })
        // window.history.back();
        return;
      }
      if(navigator.userAgent.indexOf('Electron') > -1){
        var ipcRender = top.window.ipcRender ? top.window.ipcRender : top.window.require('electron').ipcRenderer;
        //发送指令
        try {
          if (item == 'close') {
            ipcRender.send('clear');
            document.cookie = 'CMEPLAZAUSERID' + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/'
          }
          
          if (self != top && item == 'max') {
            ipcRender.send('openWindow', { 'title': $('.titleName span').text(), 'url': window.location.href });
            return;
          }
          ipcRender.send(item);
        }
        catch (e) {
          console.log("不支持ipcRenderer")
        }
      }
    },
    windowRightMenu (ev,show,top) {
      window.$nodeId = this.$store.state.nodeId;
      window.$floorflowId = this.$store.state.flowId;
      this.rMenuPos = this.calculateLocation(ev);
      if(show){
        this.rightShow = true;
      }
      //点击产品交付物
      this.haowuRight = (show == 'detail') ? false : true;
      //点击蓝条右键
      this.topRight = top ? true :false;
      this.rightMenus = top ? this.topRightMenus : this.bottomRightMenus;
    },
    setRightMenuDetail (data) {
        const fArr = flatArrMenu(data.menu);
        var tArr = [...initTreeMenu(fArr, 'childmenu', 'parentmenu', 'children'), ...data.append];
        return tArr;
    },
    initRightMenu (data,top) {
      var _this = this;
      _this.$http.get("/zciid-deliverable/activity/appbutton/getlist.json", data).then(res => {
        if (res.state == 1) {
          if(top){
            _this.topRightMenus = _this.setRightMenuDetail({ menu: res.data, append: '' });
          }else{
            _this.bottomRightMenus = _this.setRightMenuDetail({ menu: res.data, append: '' });
          }
        }
      })
    },
    //配置链接数据替换方法
    replaceDataByWell (url,menu) {
      var tsappId = '', name = window.location.hostname;
      switch (name) {
        case '520ezj.com':
          tsappId = 'zjsqsanbao';
          break;
        case '520emv.com':
          tsappId = 'zjsqxsanbao';
          break;
        case 'kh.520ezn.com':
          tsappId = 'wytdsb';
          break;
      }
      let appType = 1;
      let appId = this.$appId;
      var otherId = this.getQuery('id') || this.getQuery('thirdUrl') || this.getQuery('docId');
      let contentId = this.$contentId ? this.$contentId : otherId;
      let floorflowId = this.getQuery('floorflowId') ? this.getQuery('floorflowId') : '';
      let dataType = this.getQuery('dataType') ? this.getQuery('dataType') : '';
      let flowId = window.$floorflowId&&window.$floorflowId.id ? window.$floorflowId.id : '';
      let nodeId = window.$nodeId ? window.$nodeId : '';
      let pfId = window.$pfId ? window.$pfId : '';
      let sceneId = window.$sceneId ? window.$sceneId : '';
      let communicationId = this.getQuery('communicationId') ? this.getQuery('communicationId') : '';
      let userId = this.getQuery('nowReceiveId') ? this.getQuery('nowReceiveId') : this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : localStorage.getItem('noLoginSid');
      let userName = this.$store.state.userInfo.trueName ? this.$store.state.userInfo.trueName : localStorage.getItem('wxud')
      let contentName = $('.mainTitle').length ? $('.mainTitle')[0].innerText : $('.textTit span').length ? $('.textTit span')[0].innerText : '';
      let docId = this.getQuery('docId') ? this.getQuery('docId') : '';
      let dataId = this.getQuery('docId') || this.getQuery('thirdUrl') || this.getQuery('productUrl')|| this.getQuery('socialId') || this.getQuery('platformUrl') || this.getQuery('id') || this.$contentId || this.getQuery('pfId');
      let stanardByAppNameData = window.$item && Object.keys(window.$item).length && window.$item.others.length ? window.$item.others[0].standardData : '';
      let stanardByMainFigureData = encodeURIComponent( window.$item && Object.keys(window.$item).length && window.$item.pictures.length ? window.$item.pictures[0] : '');
      let transmitUrl = '';
      if (window.$contentWzUrl) {
        var array = window.$contentWzUrl.split('=');
        if (array.length > 2 && window.$contentWzUrl.indexOf('id=') > -1) {
          array[array.length - 1] = isYyz;
          contentWzUrlIsYyz = array.join('=');
          transmitUrl = encodeURIComponent(contentWzUrlIsYyz);
        } else {
          transmitUrl = encodeURIComponent(window.$contentWzUrl);
        }
      } else {
        transmitUrl = encodeURIComponent(window.location.href);
      }
      let publishUrl = this.getQuery('dataType') ? encodeURIComponent(window.location.href.split('?')[0] + '/odzid?id=' + this.$contentId) : encodeURIComponent(window.location.href);
      return url.replace(/(#appId)|(#flowId)|(#contentId)|(#floorflowId)|(#communicationId)|(#floorEnName)|(#userId)|(#userName)|(#contentName)|(#nodeId)|(#pfId)|(#sceneId)|(#tsappId)|(#appType)|(#name)|(#logo)|(#url)|(#publishUrl)|(#transmitUrl)|(#dataType)|(#docId)|(#dataId)|(#sign)/g, (match) => {
        if (match == '#appId') {
          return appId;
        }
        if (match == '#dataId') {
          return dataId;
        }
        if (match == '#docId') {
          return docId;
        }
        if (match == '#transmitUrl' || match == '#url') {
          if(menu.menuName.indexOf('粉丝分享')>-1){
            transmitUrl += encodeURIComponent('&showMore=false')
          }
          return transmitUrl;
        }
        if (match == '#name') {
          return stanardByAppNameData;
        }
        if (match == '#logo') {
          return stanardByMainFigureData;
        }
        if (match == '#publishUrl') {
          return publishUrl;
        }
        if (match == '#dataType' || match == '#sign') {
          return dataType;
        }
        if (match == '#tsappId') {
          return tsappId;
        }
        if (match == '#appType') {
          return appType;
        }
        if (match == '#flowId') {
          return flowId;
        }
        if (match == '#contentId') {
          return contentId;
        }
        if (match == '#floorflowId' || match == '#floorEnName') {
          return floorflowId;
        }
        if (match == '#userId') {
          return userId;
        }
        if (match == '#userName') {
          return userName
        }
        if (match == '#contentName') {
          return contentName;
        }
        if (match == '#communicationId') {
          return communicationId;
        }
        if (match == '#nodeId') {
          return nodeId;
        }
        if (match == '#pfId') {
          return pfId;
        }
        if (match == '#sceneId') {
          return sceneId;
        }
      })
    },
    xiaoYuanEditor(){
      var _this = this,noLoginSid = localStorage.getItem('noLoginSid') || '',blockName=$('.mainTitle').length ? $('.mainTitle')[0].innerText : $('.textTit span').length ? $('.textTit span')[0].innerText : '',data='',dom = $('.thumbs .detailInfor').length ? $('.thumbs .detailInfor') : $('.outDic-bottom .productBrief');
      $.each(dom, function(index, value) {
        data += $(value).html()
      })
      
      _this.$http.post("/zciid-deliverable/api/webapp/form/saveClearDel.json", {
        fileType:'doc',
        isXy:1,
        types:3,
        pfId:window.$pfId,
        userId: _this.$store.state.userInfo.userId ? _this.$store.state.userInfo.userId : noLoginSid,
        blockName:blockName,
        data:data,
        isPublic:0,
        classification:'',
        label:'',
        description:'',
        id:_this.$contentId ? _this.$contentId : (_this.getQuery('communicationId') ? _this.getQuery('communicationId') : '')
      }).then(res => {
        if (res.state == 1) {
          layer.open({
            type: 2,
            title: blockName,
            closeBtn: 1,
            area: ['100%', '100%'],
            content: location.origin + '/zciid-deliverable/form/xydoc?id='+_this.$contentId+'&pfId='+window.$pfId
          })
        }
      })
    },
    liNewHoverFun (item) {
      if(this.$store.state.userInfo.userId){
        this.addRecord(item.childmenu,item.menuName);
      }
      var aname = ['直接发布','选择发布','一键发布','更新发布','同步发布','一键更新','连载更新','一键删除','永久推送','临时推送']
      if(aname.includes(item.menuName) && !this.getQuery('showMore')){
        item.redirectUrl += '&openIssueType=none'
      }

      if (item.menuName == '抓取') {
        startGrab();
        this.rightShow = false;
        return;
      }
      if (item.menuName == '小元文档') {
        if (!this.$store.state.userInfo.userId) {
          this.handleLoginAuth();
          return;
        }
        this.xiaoYuanEditor();
        this.rightShow = false;
        return;
      }
      if (item.targetType == 'none') {
        return false;
      }
      //下载
      if (item.childmenu.indexOf("download") > -1) {
        this.downLoad();
        this.rightShow = false;
        return;
      }
      //专项发布或专项更新发布
      if (item.menuName == "专项发布" || item.menuName == "专项更新发布") {
        if (this.getQuery('dataType')) {
          this.$refs.newFlowDetail.liNewHoverFun(item, 'a');
          this.rightShow = false;
          return;
        }
      }
      //办理
      if (item.menuName == "办理") {
        this.handle();
      }
      //验收
      if (item.menuName == "验收") {
        this.checkAndAccept();
      }
      //转发
      if (item.menuName == "转发") {
        this.retransmission();
        this.rightShow = false;
        return;
      }
      //打印
      if (item.childmenu.indexOf("print") > -1) {
        this.toPrint();
        this.rightShow = false;
        return;
      }
      var id = this.getQuery('id') || this.getQuery('thirdUrl') || this.getQuery('docId');
      var exports = window.location.host, pfId;
      switch (exports) {
        case '520ezj.com':
          pfId = '228659633701650432';
          break;
        case '520emv.com':
          pfId = 'aassid-com-613446-681157-p';
          break;
        default:
          pfId = '';
          break;
      }
      //转发到商圈
      if (item.menuName.indexOf("转发到商圈") > -1) {
        if (this.getQuery('dataType')) {
          this.iframeSrc = this.getUrl(0) + (this.getUrl(0).indexOf('?') > -1 ? '&' : '?') + 'time=' + Date.now();
        } else {
          this.iframeSrc = window.location.origin + '/zciid-deliverable/interface/deliverables/transmit/circle/list?pfId=' + pfId + '&userId=' + this.userId + '&id=' + id + '&title=' + this.odzidName + '&url=' + encodeURIComponent(window.location.href) + '&time=' + Date.now();
        }
        this.rightShow = false;
        return;
      }
      //转发给好友
      if (item.menuName.indexOf("转发给好友") > -1) {
        if (this.getQuery('dataType')) {
          this.iframeSrc = this.getUrl(1) + (this.getUrl(1).indexOf('?') > -1 ? '&' : '?') + 'time=' + Date.now();
        } else {
          this.iframeSrc = window.location.origin + '/zciid-deliverable/interface/deliverables/transmit/user/list?pfId=' + pfId + '&userId=' + this.userId + '&id=' + id + '&title=' + this.odzidName + '&url=' + encodeURIComponent(window.location.href) + '&time=' + Date.now();
        }
        this.rightShow = false;
        return;
      }
      var parameter = this.$store.state.setContentIds;
      //抓取
      // if (item.menuName == "分享") {
      //   //非产品交付物右键
      //   if(!this.haowuRight){
      //     item.redirectUrl = item.redirectUrl.split('?')[0] + '?contentId=' + parameter.contentIds + '&creatUserId=' + parameter.otherDatas.userId + '&creatUserName=' + parameter.otherDatas.userName + '&userId=' + parameter.userId + '&userName=' + parameter.userName + '&photo=' + parameter.photo + '&transmitUrl=' + encodeURIComponent(this.topRight ? window.location.href : window.location.href + '&hideTop=true') + '&stanardByAppNameData=' + parameter.otherDatas.stanardByAppNameData + '&stanardByMainFigureData=' + parameter.otherDatas.stanardByMainFigureData + '&stanardByBasicPriceData=' + parameter.otherDatas.stanardByBasicPriceData + '&stanardByVideoShowData=' + parameter.otherDatas.stanardByVideoShowData + '&pfId=' + window.$pfId;
      //   }
      // }
      //二维码生成
      if (item.menuName.indexOf("二维码生成") > -1) {
        this.iframeSrc = window.location.origin + "/uoqid/toQrcode?url=" + encodeURIComponent(window.location.href) + "&pfId=" + pfId + "&userId=" + this.userId + '&time=' + Date.now();
        this.rightShow = false;
        return;
      }
      if (item.redirectUrl) {
        item.redirectUrl = this.replaceDataByWell(item.redirectUrl,item)
        if (item.childmenu == 'changeFloorType' || item.childmenu == 'changeBlockType') {
          item.redirectUrl = item.redirectUrl + '&type=' + (this.$route.query.diyPageFlowId ? 'diy-page' : 'index');
        }
        if (item.childmenu == 'ztpzyj') {
          this.iframeSrc == item.redirectUrl + (item.redirectUrl.indexOf('?') > -1 ? '&' : '?') + 'time=' + Date.now();
        }
      }
      var left = (window.innerWidth - 900) / 2;
      var wH = (window.innerHeight / 2) - 100;
      if (item.targetType == "opeFrame") {
        if (item.childmenu == 'ZSZKBYJ-index-20201207095556-zTdpF4M1-quote-ZNYJTYPT') {
          item.redirectUrl = item.redirectUrl + `&pfId=${window.$pfId}`
        }
        if (item.childmenu == 'platDeliveryConfig') {
          var nodeId = window.$nodeId;
          item.redirectUrl = item.redirectUrl + `&pfId=${window.$pfId}&account=${window.$pfId}`
          if (!nodeId) {
            this.$notify({
              position: 'top-right',
              title: '提示',
              message: '该节点不是流程块，无工作标签！',
              type: 'warning',
              offset: wH
            });
            return;
          }
        }
      }
      if (item.menuName == '登录') {
        if (this.$store.state.userInfo.userId) {
          this.rightShow = false;
          return;
        }
        const _toHref = `${window.location.origin}${window.location.pathname}${window.location.search}`;
        window.location.href = `${document.location.origin}/cme-sso-app/login?servers=${encodeURIComponent(`${document.location.origin}/uoqid/sso/login?toUrl=${encodeURIComponent(_toHref)}`)}`
        return;
      }
      if (item.menuName == '退出登录') {
        if (!this.$store.state.userInfo.userId) {
          this.rightShow = false;
          return;
        }
        this.handleLogout();
        return;
      }
      //加入购物车
      if (item && (item.childmenu == "addToCart" || item.childmenu == "addToCart2") && window.$rightLeft.center && window.$rightLeft.center.standardJson) {
        let productId = window.$rightLeft.center.contentId;
        this.joinShopCart(productId, window.$rightLeft.center.standardJson);
        return;
      }
      if (item.targetType == "opeFrame" || item.targetType == "newblank" || item.targetType == "diy-workbench" || item.targetType == "diy-scene") {

        if (this.isFlowDetail) {
          // 是详情页
          layer.open({
            type: 2,
            title: item.menuName,
            closeBtn: 1,
            area: ['100%', '100%'],
            content: item.redirectUrl //iframe的url
          })
        } else {
          // 外展交付物页
          this.iframeSrc = item.redirectUrl + (item.redirectUrl.indexOf('?') > -1 ? '&' : '?') + 'time=' + Date.now();
        }
        this.rightShow = false;
      }
    },
    //加入购物车 所需参数拼接
    joinShopCart (pId, allTagsJson) {
      var asset = this.getQuery('assetId');
      this.messages = [];
      this.requiredMsgs = [];
      //产品名称
      var chanpinmingchen = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'appName').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'appName')[0].standardData : this.getStandardData(['名称', '组织名称', '企业名称', '个人名称', '产品名称', '图片名称'], 'required', '', allTagsJson);
      //产品图片
      var chanpintupian = allTagsJson.filter((tags)=>tags.fileTypeDetail == 2&&tags.standardData).length  ? allTagsJson.filter((tags)=>tags.fileTypeDetail == 2&&tags.standardData)[0].standardData : '';
      //单价
      var price = allTagsJson.filter((tags) => tags.standardData && (tags.standardEnName == 'cpyxprice'||tags.standardEnName == 'xmjcprice'||tags.standardEnName == 'basicPrice'));
      var danjia = price.length ? (price ? price[0].standardData : '') : this.getStandardData(['', '基础价格', '产品基础标签', '产品价格', '价格', '基准价', '金额'], 'number', '', allTagsJson);
      //数量
      var shuliang = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'number').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'number')[0].standardData : this.getStandardData('数量', 'number', '1', allTagsJson);
      //用户ID
      var userId = this.$store.state.userInfo.userId ? this.$store.state.userInfo.userId : '';
      //产品标识
      var productId = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'productMarking').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'productMarking')[0].standardData : '';
      //资产交易价
      var assetsPrice = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'assetsPrice').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'assetsPrice')[0].standardData : '';
      //资产单位
      var assetsUnit = asset ? assetsPrice.replace(parseFloat(assetsPrice)+ '/','') : allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'assetsUnit').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'assetsUnit')[0].standardData : '';
      //租赁交易价
      var periodicPrice = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'periodicPrice').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'periodicPrice')[0].standardData : '';
      //租赁单位
      var periodicUnit = asset ? periodicPrice.replace(parseFloat(periodicPrice)+ '/','') : allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'periodicUnit').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'periodicUnit')[0].standardData : '';
      //次数租赁价
      var timesPrice = allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'timesPrice').length ? allTagsJson.filter((tags) => tags.standardEnName && tags.standardEnName == 'timesPrice')[0].standardData : '';
      //次数租赁单位
      var timesUnit = timesPrice.replace(parseFloat(timesPrice)+ '/','');
      // if (!userId) {
      //   this.$notify({
      //     title: '提示',
      //     message: '请先登录',
      //     type: 'warning',
      //   });
      //   return;
      // }
      if ((this.requiredMsgs.length > 0 || !chanpintupian || !danjia) && !assetsPrice && !periodicPrice) {
        this.$notify({
          title: '提示',
          message: `(产品名称或图片名称、产品图片、单价)为必填选项，请去补充标签，并生成，再进行此操作`,
          type: 'warning',
          duration: 5000
        });
        return;
      }

      if (this.messages.length > 0) {
        this.$notify({
          title: '提示',
          message: `${this.messages.join('、')}，的值不是数字类型，请输入阿拉伯数字`,
          type: 'warning',
          duration: 5000
        });
        return;
      }
      if (danjia == '面议') {
        this.$notify({
          title: '提示',
          message: '此产品不支持加入购物车',
          type: 'warning',
          duration: 5000
        });
        return;
      }
      if (!productId&&!asset) {
        this.$notify({
          title: '提示',
          message: '该产品暂不能购买',
          type: 'warning',
        });
        return;
      }
      var productInfo = window.$rightLeft.center.item,
          prevMerchantId = this.getQuery('prevMerchantId'),
          prevMerchantName=this.getQuery('prevMerchantName'),
          prevTypes=decodeURIComponent(this.getQuery('prevTypes')),
          prevPfId=this.getQuery('prevPfId'),
      cart = {
        productName: chanpinmingchen,
        productImg: chanpintupian,
        prices: this.$store.state.memberLevel && productInfo[this.getMemberLevel(this.$store.state.memberLevel).memberLevel] && productInfo.memberEndTime ? productInfo[this.getMemberLevel(this.$store.state.memberLevel).memberLevel] : (assetsPrice ? assetsPrice : (periodicPrice ? periodicPrice : (productInfo.discountTypes == 'seckill' ? productInfo.priceType : danjia))),
        activityType: this.$store.state.memberLevel && productInfo[this.getMemberLevel(this.$store.state.memberLevel).memberLevel] && productInfo.memberEndTime ? 'blankVip' : (productInfo.discountTypes ? productInfo.discountTypes : ''),
        activityEndTime: productInfo.endTime,
        buyNumber: shuliang,
        userId: userId ? userId : '',
        codes: userId ? '' : (this.getQuery('localUserId') ? this.getQuery('localUserId') : localStorage.getItem('wxud')),
        productId:asset ? ('asset-' + asset) : (productId ? (productId + '-' + pId) : (pId ? pfId : this.getQuery('pfId'))),
        wzAppId: productInfo.appId ? productInfo.appId : '',
        units: assetsPrice ? assetsUnit : (periodicPrice ? periodicUnit : '个'),
        dataType: assetsPrice ? 1 : (periodicPrice ? 2 : 0),
        merchantId: prevMerchantId ? prevMerchantId : productInfo.appId,
        merchantName: prevMerchantName ? prevMerchantName : productInfo.appName,
        payPfId: window.$pfId ? window.$pfId : '',
        types: (prevPfId ? prevPfId : (window.$pfId ? window.$pfId : '')) ==  (window.$pfId ? window.$pfId : '')? 1 : 2,
        detailsUrl:location.href,
        // detailsUrl:'',
        pfId: prevPfId ? prevPfId : (window.$pfId ? window.$pfId : '')
      };
      
      if (assetsPrice && periodicPrice) {
        window.$chooseToCart = true;
        this.chooseToCart(parseFloat(assetsPrice), assetsUnit, parseFloat(periodicPrice), periodicUnit, JSON.stringify(cart).replace(/"/g, '&quot;'),'','',parseFloat(timesPrice),timesUnit);
        return;
      } else {
        window.$chooseToCart = false;
      }
      this.$http
        .post('/oqmid-pay-tool-web/shop/cart/save', { arrs: JSON.stringify(cart) }, 'a')
        .then(res => {
          if (res.state == 1) {
            const h = this.$createElement;
            this.$notify({
              title: '提示',
              dangerouslyUseHTMLString: true,
              type: 'success',
              duration: 3000,
              message: h('div', { class: 'personnel' }, [
                h('p', { class: 'isCreate' }, '加入购物车成功！'),
                h('button', {
                  class: 'personnel-btn', on: {
                    click: this.toOpen
                  }
                }, '购物车')
              ]),
            })
          }else{
            this.$notify({
              title: '提示',
              message: `该产品暂不支持购买`,
              type: 'warning',
              duration: 5000
            });
          }
        });
    },
    toOpen(){
      this.$notify.closeAll();
      this.handleShopCart();
    },
    //标签取值方法
    getStandardData (nameArr, type, nameData, allTagsJson) {
      const allTagsStandArr = allTagsJson;
      const sNames = (typeof nameArr == 'string') ? [nameArr] : nameArr;
      var filterStandArr = allTagsStandArr.filter((ite) => sNames.indexOf(ite.standardName) > -1);
      var filterData = filterStandArr[0] ? filterStandArr[0].standardData : nameData;
      var message = '';
      var requiredMsg = '';
      switch (type) {
        case 'required':
          if (!filterData) {
            requiredMsg = `${sNames[0]}`;
          }
          break;
        case 'number':
          if (isNaN(filterData)) {
            message = `${sNames[0]}`;
          }
          break;
      }
      if (requiredMsg) {
        this.requiredMsgs.push(requiredMsg);
      }
      if (message) {
        this.messages.push(message);
      }
      return filterData;
    },
  }
}
</script>
<style scoped>

/*顶部导航 开始*/
.navbars {
  height: 60px;
  background-color: #356eb3;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  -webkit-app-region: drag;
  -webkit-user-select: none;
}
.navbars.specialTop{
  justify-content: flex-end;
  height: 32px;
}
.navbars .nav-left,
.navbars .nav-right {
  height: 100%;
  -webkit-app-region: no-drag;
}
.navbars .nav-center {
  height: 40px;
  flex-grow: 1;
  padding-left: 45px;
  -webkit-app-region: no-drag;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #fff;
}
.navbars .nav-center span {
  font-size: 12px;
  padding: 0 10px;
  cursor: pointer;
}
.navbars .left {
  color: #fff;
  margin: 10px 0 0 16px;
}
.navbars .left .logo-box {
  margin-left: 16px;
  padding-top: 10px;
  display: block;
}

.navbars .left .logo-box .img-box {
  width: 38px;
  height: 38px;
  overflow: hidden;
  text-align: center;
  line-height: 38px;
  margin-right: 8px;
  font-size: 0;
}

.navbars .left .logo-box .img-box img {
  width: 38px;
  height: 38px;
  vertical-align: middle;
}
.navbars .left .logo-box .tit {
  line-height: 38px;
}
.navbars .left .logo-box .tit span {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}
.navbars .right {
  line-height: 28px;
  /* margin: 0 12px; */
  display: flex;
}
.navbars .right .icon-box {
  display: flex;
  align-items: center;
}
.navbars .right .icon-box .setup {
  padding: 0 8px;
  cursor: pointer;
  height: 28px;
}
.navbars .right .icon-box .pictures {
  font-size: 0;
}
.navbars .right .icon-box .setup:hover {
  /* background-color: #729aca; */
  background-color: #225da4;
}

.navbars .right .icon-box .setup img {
  vertical-align: middle;
  width: 13px;
  height: 13px;
}

.navbars .right .suofang.curr img.small {
  display: inline-block;
}
/*顶部导航 结束*/
/* 内容页面 开始*/
.main-box {
  width: 260px;
  height: 80px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -70px 0 0 -130px;
}
.main-box .left-num {
  text-align: center;
}
.main-box .left-num .img-box img {
  width: 88px;
  height: 88px;
}
/* 商品介绍 */
.Introduction{
  padding: 0 20px 20px;
}
.Introduction span{
  display:inline-block;
  margin-top:20px;
  color:#333;
  font-size:14px;
  text-indent: 28px;
}
.Introduction img{
  display:block;
  margin:20px auto 0;
  max-width:100%;
}

.slideshow,.havrTransform {
  font-size: 0;
}
.slideshow.isload{
  opacity:0
}
.showHave,
.slideshow,
.havrTransform,
#app {
  height: 100%;
  /* width: calc(100% - 1px); */
}
#detail-content ul .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}
#detail-content ul .swiper-slide img.notdefault {
  width: 100%;
  height: auto;
}
#detail-content ul .swiper-slide img.isdefault {
  width: auto;
  height: 100%;
}
.bottom-box-right {
  height: 292px;
  padding: 18px 20px;
}
@media screen and (max-width: 244px) {
  .navbars .right.fr {
    display: none;
  }
}

@media screen and (max-width: 400px) {
  .z-container.setShow{
    width: 100px !important;
  }
}
@media screen  and (max-width: 611px) {
  .navbars .icon-box {
    display: none !important;
  }
  .navbars.specialTop .icon-box {
    display: flex !important;
  }
  .left .title {
    padding: 0 5px !important;
  } 
  .navbars .nav-center{
    display: none;
  }
  .left .metaverse {
    padding-left: 5px !important;
  }
}
@media screen  and (min-width: 480px) and (max-width: 533px) { 
  .navbars .nav-center{
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .englishName {
    overflow: hidden;
    height: 18px;
  }
  .left.fl {
    max-width: 243px;
    margin-left: 6px;
  }
  .left.fl .title .titleName {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 119px !important;
  }
  .setup {
    padding: 0 5px !important;
  }
  .thirdUrlError div {
    max-width: 250px;
  }
}

.left.fl .title>div{
    max-width: 238px;
    overflow: hidden;
  }

@media screen and (min-width: 769px) and (max-width: 910px) {
  .left.fl .title .titleName{
    max-width: 136px !important;
    overflow: hidden;
  }
}
@media screen and (max-width: 347px) {
  .left.fl .title .titleName {
    max-width: 82px !important;
  } 
}
@media screen and (max-width: 312px) {
  .left.fl .title .titleName {
    max-width: 62px !important;
  } 
}
@media screen and (max-width: 293px) {
  .metaverse {
    display: none;
  } 
}
.englishName {
  font-size: 12px;
}
.picture {
  margin: auto;
}
.selects {
  width: 160px;
  border: 1px solid #aaa;
  background-color: #fff;
  box-sizing: border-box;
  position: absolute;
  right: 0;
  top: 35px;
  z-index: 9999999;
}
.selects span {
  display: block;
  padding: 4px;
}
.selects input {
  width: 100%;
  padding: 4px !important;
  border: 1px solid #aaa;
}
.selects>ul {
  height: 200px;
  overflow-y: auto;
}
.selects ul li {
  padding: 6px;
}
.changeColors {
  color: black;
}
.changeColors:hover {
  background-color: #5897fb !important;
  color: white;
  /* 过年主题 */
  /* background-color: #ee8785 !important; */
}
.selcctChoice {
  position: absolute;
  right: -18px;
  top: 13px;
  cursor: pointer;
  -webkit-app-region: no-drag;
  
}
.selcctChoice .selcctChoice-C .selcctChoice-C-l{
  color: black;
}

.selcctChoice .selcctChoice-C .selcctChoice-C-l:hover{
  color: white;
  background-color: #5897fb;
}
.selcctChoice .GRLI-sortadd{
  width: 100%;
  line-height: 30px;
  background: #eee;
  font-size: 12px;
  color: #999;
  text-align: center;
  box-sizing: border-box;
  overflow: hidden;
}
.selcctChoice .GRLI-sortadd a{
  color: #4c9dfb;
}
.selcctChoice .GRLI-sortadd a img{
  display: inline-block;
  vertical-align: middle;
  margin: -2px 4px 0 0;
}
.left.fl {
  position: relative;
}
.left.fl .title {
  padding: 0 10px;
  line-height: 38px;
}
.left.fl .title .titleName {
  font-size: 17px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 238px;
}
.left .metaverse {
  border-left: 1px dashed #d0d0d0;
  padding-left: 10px;
  cursor: pointer;
}
.picture img {
  width: 30px;
  height: 30px;
}
.icon-box li {
  -webkit-app-region: no-drag;
}
.thirdUrlError {
  width: 100%;
  /* height: calc(100% - 36px); */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.thirdUrlError div a,
.thirdUrlError div span {
  display: block;
  font-size: 12px;
}
.thirdUrlError div a {
  color: #356eb3;
}
.thirdUrlError span,
.thirdUrlError a {
  margin-top: 20px;
}
.startIframe {
  width: 100%;
  /* height: calc(100% - 36px); */
  font-size: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.startIframe img {
  width: 120px;
  height: 120px;
}
.startIframe div:first-child {
  margin-top: -40px;
}
.startIframe div:nth-child(2),
.startIframe div:nth-child(3) {
  margin-top: 40px;
  color: #333;
  font-size: 20px;
}
.startIframe div:nth-child(3) {
  margin-top: 20px;
}
.backgroundDiv {
  width: 6px;
  height: 587px;
  z-index: -1;
  top: -24px;
  position: absolute;
  background-color: #356eb3;
}
.suspendShow {
  width: 640px;
  height: 213px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  background-color: #fff;
  position: absolute;
  bottom: 20px;
  left: -876px;
}
/* .open:hover .hovers {
  display: block;
} */
.imageText:hover span {
  color: #4c9dfb;
}

.open {
  width: 100px;
  height: 100px;
  position: fixed;
  bottom: 60px;
  right: 0;
  /* padding-left: 10px; */
  cursor: pointer; 
  z-index: 9999;
  background: url("../assets/online_service.png") no-repeat 32px 25px;
}
.open span{
  position:absolute;
  font-size:12px;
  color:#333;
  word-break: keep-all;
  top:66px;
  left:27px;
}
.open .hovers li,
.open .hoversTwo li {
  height: 28px;
  width: 100%;
  line-height: 28px;
  padding: 0 20px 0 10px;
  display: flex;
  align-items: center;
  color: #333;
  box-sizing: border-box;
  position: relative;
}
.open .hovers li .redpoint{
  top: 6px;
  left: 58px;
  width: 4px;
  height: 4px;
}
.open .hovers li:hover {
  background-color: #f5f7fa;
}

.open .hovers,
.open .hoversTwo {
  position: absolute;
  bottom: 20px;
  width: 128px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  padding: 6px 0;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 2px;
  overflow-y: auto;
  overflow-x: hidden;
}
.open .hovers{
  max-height: 213px;
}
.open .hoversTwo {
  height: 213px;
}
.open .redpoint{
  position: absolute;
  top: 25px;
  left: 60px;
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background: #ff1919;
}
.hovers {
  left: -108px;
  display: none;
}
.hoversTwo {
  left: -236px;
}
.hovers li:nth-child(2):hover + .hoversTwo {
  display: block;
}
.hovers::-webkit-scrollbar {
  width: 5px;
}
.hovers::-webkit-scrollbar-track {
  background: #eee;
  border-radius: 5px;
}
.hovers::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 5px;
}
.hovers img {
  position: absolute;
  right: -8px;
  bottom: 22px;
}
/* .open:hover .other {
  display: block;
} */
.other {
  position: absolute;
  bottom: 0;
  left: -113px;
  display: none;
  width: 113px;
  height: 188px;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  padding: 4px 10px;
  box-sizing: border-box;
  background-color: #fff;
}
.other li {
  height: 26px;
  width: 82px;
  text-align: left;
  line-height: 26px;
  cursor: pointer;
  padding-left: 10px;
}
.other img {
  position: absolute;
  right: -8px;
  bottom: 22px;
}
.other li:hover {
  background-color: #4c9dfb;
  color: #fff;
}

.imageText {
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  height: 100px;
  background-color: #fff;
  border-radius: 2px;
}
.imageText img {
  margin-top: 16px;
}
.imageText span {
  margin-top: 8px;
}

html,
body {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
}
.bottom {
  /* height: 36px; */
  background-color: #efefef;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 10px 0;
  box-sizing: border-box;
}
.bottom span,
.bottom a {
  color: #999;
}
.bottom a:hover {
  color: #2f8eed;
  cursor: pointer;
}
/* .iframeShow{
  height:calc(100% - 36px);
} */
@media screen and (max-width: 250px) {
  .bottom{
    height: 54px;
    position:fixed;
    bottom:0;
    z-index: 99;
  }
  /* .iframeShow{
    height:calc(100% - 54px);
  } */
}
.showHave .titles {
  height: 38px;
  line-height: 38px;
  border-bottom: 1px solid #0c78cf;
  background: #f7f7f7;
  overflow: hidden;
  display: flex;
}
.showHave .haveParameter{
  height:calc(100% - 60px);
  position:relative;
}
.showHave .haveParameter .showMore.retract:hover .text{
  color: #2f8eed;
  background-color: #ecf6ff;
}
.showHave .haveParameter .showMore .text{
  height:45px;
  line-height: 45px;
  text-align: center;
  font-size: 14px;
  background-color: #f7f7f7;
  color: #999;
  border-radius: 6px;
}
.showHave .haveParameter .showMore .text a{
  margin-right: 10px;
}
.showHave .haveParameter .showMore .image{
  text-align: center; 
  margin-bottom: 10px;
}
.showHave .haveParameter .showMore .image img{
  width: 12px;
  height: 12px;
}
.showHave .showHave-l{
  width:100%;
  height:calc(100% - 60px);
  font-size:0;
}
.titles li.curr {
  background: #0c78cf;
}
.titles li.curr a {
  color: #fff;
  padding: 0 20px;
  font-size: 14px;
}
.floorBox{
  margin:20px auto;
  border: 1px solid #ddd;
  box-sizing: border-box;
  position: relative;
  font-size: 0;
}
.floorBox .tab{border-bottom: 1px solid #ddd; line-height: 36px; font-size: 14px; margin: 0 16px;}
.floorBox .tab .arrow-box-left {width: 18px;height: 37px;text-align: center;cursor: pointer;background: #efefef;position: relative;z-index: 1;}
.floorBox .tab .arrow-box-left img{display: block;width: 6px;vertical-align: middle;margin: 13px auto 0;transform: rotate(180deg);}
.floorBox .tab .arrow-box-right {width: 18px;height: 37px;text-align: center;cursor: pointer;background: #efefef;position: relative;z-index: 1;}
.floorBox .tab .arrow-box-right img{display: block;width: 6px;vertical-align: middle;margin: 13px auto 0;}
.floorBox .tab .tab-box{width: calc(100% - 36px);overflow: hidden;}
.floorBox .tab .tab-change{width: 340px; transition: all .3s;}
.floorBox .tab .row{margin: 0 10px;}
.floorBox .tab .row.curr{border-bottom: 1px solid #0c78cf; color: #0c78cf;}
.floorBox .tab .row.curr a{color: #0c78cf;}
.floorBox .tab .row:first-child{margin-left: 16px;}
.floorBox .tab .row a{display: block; width: 100%; height: 100%;font-size: 14px;}
.floorBox .tab .row a:hover{color: #0c78cf;}

.advertisement{
  height:62px;
}
.advertisement .knowMore{
  position: absolute;
  top: 15px;
  right: 20px;
  cursor: pointer;
}
.advertisement .knowMore:hover{
  transform: scale(1.02);
}
.advertisement .knowMore:active{
  transform: scale(0.98);
}
.advertisement .backImg{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.related-articles{
  margin:16px 20px 0;
  padding-bottom:16px;
  display:flex;
  border-bottom:1px dashed #ddd;
  cursor:pointer;
}
.related .related-articles.last{
  border-bottom:0;
}
.related-articles:first-child{
  margin-top:20px;
}

.related-articles .related-articles-imgOrVideo{
  width:140px;
  height:94px;
  /* 防止宽度压缩 */
  flex-shrink: 0;
  flex-grow: 0;
}
.related-articles .related-articles-imgOrVideo.gzkh img{
  object-fit: contain;
  box-shadow: 0 1px 5px rgba(206, 204, 204, 0.4);
}
.related-articles .content{
  background-color: #fff;
  padding: 0;
}
.related-articles-text,.related-articles .content{
  margin-left:16px;
  width: calc(100% - 140px);
}
.related-articles .related-articles-text-title{
  font-size:18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color:#333;
  margin-bottom:7px;
}
.related-articles-text .related-articles-text-content{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-wrap: break-word;
  color:#333;
  margin-bottom:7px;
  height:38px;
}
.related-articles .related-articles-text-article{
  font-size:12px;
  color:#666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.related-articles-text span{
  font-size:14px;
  display:block;
}
.noIntroduction{
  height:360px;
  width:100%;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
}
.noIntroduction span{
  color:#999;
  margin-top:12px;
  font-size:18px;
}
#detail-content {
  width: 100%;
  height: 100%;
}
#detail-content .arrow-left {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  left: 0;
  background: url("~@/assets/images/product_detail/recommend_arrow_left.png")
    no-repeat center;
  cursor: pointer;
}
#detail-content .arrow-right {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  right: 0;
  background: url("~@/assets/images/product_detail/recommend_arrow_right.png")
    no-repeat center;
  cursor: pointer;
}
#detail-content ul li img {
  height: 100%;
}
.shiyong-client {
  width: 100%;
  height: calc(100% - 60px);
}

</style>
<style lang="scss">
@import "../assets/css/specialBack.css";
.Introduction .control video{
  margin-top:20px;
}
</style>




// WEBPACK FOOTER //
// src/template/SlideshowAllShow.vue







// WEBPACK FOOTER //
// src/template/SlideshowAllShow.vue